/* eslint-disable object-curly-spacing */
/* eslint-disable quote-props */
/* eslint-disable key-spacing */
/* eslint-disable quotes */
// <script>
import Vue from 'vue'
import { EnumType } from './enums.base.js'
export { EnumType }

class YesOrNoType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'No',
        text: '否',
        textPy: 'F',
        label: '否',
        color: 'red',
        icon: 'do_disturb_on',
        meta: null
      },

      {
        value: 1,
        name: 'Yes',
        text: '是',
        textPy: 'S',
        label: '是',
        color: 'primary',
        icon: 'check_circle',
        meta: null
      }

    ], '是否', 'offline_pin')
  }

  get No () {
    return 0
  }

  get Yes () {
    return 1
  }
}

export const YesOrNo = Object.freeze(new YesOrNoType())

class OrderStateType extends EnumType {
  constructor () {
    super([

      {
        value: 1,
        name: 'Success',
        text: '预约成功',
        textPy: 'S',
        label: '预约成功',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Canceled',
        text: '已取消',
        textPy: 'C',
        label: '已取消',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'PassiveCanceled',
        text: '被取消',
        textPy: 'P',
        label: '被取消',
        color: '',
        icon: '',
        meta: null
      }

    ], '预约状态', 'offline_pin')
  }

  get Success () {
    return 1
  }

  get Canceled () {
    return 2
  }

  get PassiveCanceled () {
    return 3
  }
}

export const OrderState = Object.freeze(new OrderStateType())

class TestResultType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Unknown',
        text: '待检',
        textPy: 'DJ',
        label: '待检',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Positive',
        text: '阳性',
        textPy: 'YX',
        label: '阳性',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Negative',
        text: '阴性',
        textPy: 'Y',
        label: '阴性',
        color: '',
        icon: '',
        meta: null
      }

    ], '检测结果', 'offline_pin')
  }

  get Unknown () {
    return 0
  }

  get Positive () {
    return 1
  }

  get Negative () {
    return 2
  }
}

export const TestResult = Object.freeze(new TestResultType())

class ComponentTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 1,
        name: 'house',
        text: '献血屋',
        textPy: 'H',
        label: '献血屋',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'car',
        text: '献血车',
        textPy: 'C',
        label: '献血车',
        color: '',
        icon: '',
        meta: null
      }

    ], '站点类型', 'offline_pin')
  }

  get house () {
    return 1
  }

  get car () {
    return 2
  }
}

export const ComponentType = Object.freeze(new ComponentTypeType())

class TestConclusionType extends EnumType {
  constructor () {
    super([

      {
        value: 1,
        name: '',
        text: '献血屋',
        textPy: 'H',
        label: '献血屋',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'car',
        text: '献血车',
        textPy: 'C',
        label: '献血车',
        color: '',
        icon: '',
        meta: null
      }

    ], '初筛结果', 'offline_pin')
  }

  get () {
    return 1
  }

  get car () {
    return 2
  }
}

export const TestConclusion = Object.freeze(new TestConclusionType())

class BloodTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 1,
        name: 'whole',
        text: '全血',
        textPy: 'W',
        label: '全血',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'component',
        text: '成分血',
        textPy: 'C',
        label: '成分血',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'all',
        text: '全血/成分血',
        textPy: 'C',
        label: '全血/成分血',
        color: '',
        icon: '',
        meta: null
      }

    ], '采血类型', 'offline_pin')
  }

  get whole () {
    return 1
  }

  get component () {
    return 2
  }

  get all () {
    return 3
  }
}

export const BloodType = Object.freeze(new BloodTypeType())

class CollectMethodsType extends EnumType {
  constructor () {
    super([

      {
        value: 1,
        name: 'machine',
        text: '机采',
        textPy: 'W',
        label: '机采',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'manual',
        text: '人工',
        textPy: 'C',
        label: '人工',
        color: '',
        icon: '',
        meta: null
      }

    ], '采血方式', 'offline_pin')
  }

  get machine () {
    return 1
  }

  get manual () {
    return 2
  }
}

export const CollectMethods = Object.freeze(new CollectMethodsType())

class SexType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Male',
        text: '男',
        textPy: 'NAN',
        label: '男',
        color: 'primary',
        icon: 'ion-male',
        meta: null
      },

      {
        value: 1,
        name: 'Female',
        text: '女',
        textPy: 'NV',
        label: '女',
        color: 'pink',
        icon: 'ion-female',
        meta: null
      }

    ], '性别', 'wc')
  }

  get Male () {
    return 0
  }

  get Female () {
    return 1
  }
}

export const Sex = Object.freeze(new SexType())

class BloodGroupType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'A',
        text: 'A',
        textPy: 'A',
        label: 'A',
        color: 'yellow-9',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'B',
        text: 'B',
        textPy: 'B',
        label: 'B',
        color: 'red',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'O',
        text: 'O',
        textPy: 'O',
        label: 'O',
        color: 'blue',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'AB',
        text: 'AB',
        textPy: 'AB',
        label: 'AB',
        color: 'green',
        icon: '',
        meta: null
      }

    ], '血型', 'opacity')
  }

  get A () {
    return 0
  }

  get B () {
    return 1
  }

  get O () {
    return 2
  }

  get AB () {
    return 3
  }
}

export const BloodGroup = Object.freeze(new BloodGroupType())

class BloodRhType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Positive',
        text: '+',
        textPy: '+',
        label: '+',
        color: '',
        icon: '',
        meta: {"labelStyle":"font-size: 2em"}
      },

      {
        value: 1,
        name: 'Negative',
        text: '-',
        textPy: '-',
        label: '-',
        color: '',
        icon: '',
        meta: {"labelStyle":"font-size: 2em"}
      }

    ], 'Rh(D)', 'bloodtype')
  }

  get Positive () {
    return 0
  }

  get Negative () {
    return 1
  }
}

export const BloodRh = Object.freeze(new BloodRhType())

class IdCardTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Default',
        text: '身份证',
        textPy: 'SFZ',
        label: '身份证',
        color: '',
        icon: '',
        meta: {"mask":"#################X"}
      },

      {
        value: 1,
        name: 'Hm',
        text: '港澳通行证',
        textPy: 'GATXZ',
        label: '港澳通行证',
        color: '',
        icon: '',
        meta: {"mask":"XXXXXXXXXXXXXXXXXX"}
      },

      {
        value: 2,
        name: 'Tw',
        text: '台湾通行证',
        textPy: 'TWTXZ',
        label: '台湾通行证',
        color: '',
        icon: '',
        meta: {"mask":"XXXXXXXXXXXXXXXXXX"}
      },

      {
        value: 3,
        name: 'Passport',
        text: '护照',
        textPy: 'HZ',
        label: '护照',
        color: '',
        icon: '',
        meta: {"mask":"XXXXXXXXXXXXXXXXXX"}
      },

      {
        value: 4,
        name: 'Army',
        text: '军官证',
        textPy: 'JGZ',
        label: '军官证',
        color: '',
        icon: '',
        meta: {"mask":"XXXXXXXXXXXXXXXXXX"}
      }

    ], '证件类型', 'style')
  }

  get Default () {
    return 0
  }

  get Hm () {
    return 1
  }

  get Tw () {
    return 2
  }

  get Passport () {
    return 3
  }

  get Army () {
    return 4
  }
}

export const IdCardType = Object.freeze(new IdCardTypeType())

class BloodUnitType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Ml',
        text: 'mL',
        textPy: 'HS',
        label: 'mL',
        color: 'deep-orange-10',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'U',
        text: 'U',
        textPy: 'DW',
        label: 'U',
        color: 'orange-7',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: '治疗量',
        text: '治疗量',
        textPy: 'ZLL',
        label: '治疗量',
        color: 'orange-7',
        icon: '',
        meta: null
      }

    ], '血量单位', 'straighten')
  }

  get Ml () {
    return 0
  }

  get U () {
    return 1
  }

  get 治疗量 () {
    return 2
  }
}

export const BloodUnit = Object.freeze(new BloodUnitType())

class WordEntryStateType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Created',
        text: '已创建',
        textPy: 'YCJ',
        label: '已创建',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Enabled',
        text: '已启用',
        textPy: 'YQY',
        label: '已启用',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Disabled',
        text: '已禁用',
        textPy: 'YJY',
        label: '已禁用',
        color: '',
        icon: '',
        meta: null
      }

    ], '词条状态', '')
  }

  get Created () {
    return 0
  }

  get Enabled () {
    return 1
  }

  get Disabled () {
    return 2
  }
}

export const WordEntryState = Object.freeze(new WordEntryStateType())

class EducationDegreeType extends EnumType {
  constructor () {
    super([

      {
        value: 1,
        name: 'PrimarySchool',
        text: '小学',
        textPy: 'XX',
        label: '小学',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'MiddleSchool',
        text: '中学',
        textPy: 'ZX',
        label: '中学',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'HighSchool',
        text: '高中',
        textPy: 'GZ',
        label: '高中',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'PolytechnicSchool',
        text: '中专',
        textPy: 'ZZ',
        label: '中专',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 5,
        name: 'JuniorCollege',
        text: '大专',
        textPy: 'DZ',
        label: '大专',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 6,
        name: 'UndergraduateCourse',
        text: '本科',
        textPy: 'BK',
        label: '本科',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 7,
        name: 'Master',
        text: '硕士',
        textPy: 'SS',
        label: '硕士',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 8,
        name: 'Dr',
        text: '博士',
        textPy: 'BS',
        label: '博士',
        color: '',
        icon: '',
        meta: null
      }

    ], '文化程度', '')
  }

  get PrimarySchool () {
    return 1
  }

  get MiddleSchool () {
    return 2
  }

  get HighSchool () {
    return 3
  }

  get PolytechnicSchool () {
    return 4
  }

  get JuniorCollege () {
    return 5
  }

  get UndergraduateCourse () {
    return 6
  }

  get Master () {
    return 7
  }

  get Dr () {
    return 8
  }
}

export const EducationDegree = Object.freeze(new EducationDegreeType())

class NationType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'HanZu',
        text: '汉族',
        textPy: 'HZ',
        label: '汉族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'MengGuZu',
        text: '蒙古族',
        textPy: 'MGZ',
        label: '蒙古族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'HuiZu',
        text: '回族',
        textPy: 'HZ',
        label: '回族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'ZangZu',
        text: '藏族',
        textPy: 'CZ',
        label: '藏族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'WeiWuErZu',
        text: '维吾尔族',
        textPy: 'WWEZ',
        label: '维吾尔族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 5,
        name: 'MiaoZu',
        text: '苗族',
        textPy: 'MZ',
        label: '苗族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 6,
        name: 'YiZu',
        text: '彝族',
        textPy: 'YZ',
        label: '彝族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 7,
        name: 'ZhuangZu',
        text: '壮族',
        textPy: 'ZZ',
        label: '壮族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 8,
        name: 'BuYiZu',
        text: '布依族',
        textPy: 'BYZ',
        label: '布依族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 9,
        name: 'ChaoXianZu',
        text: '朝鲜族',
        textPy: 'CXZ',
        label: '朝鲜族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 10,
        name: 'ManZu',
        text: '满族',
        textPy: 'MZ',
        label: '满族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 11,
        name: 'DongZu',
        text: '侗族',
        textPy: 'DZ',
        label: '侗族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 12,
        name: 'YaoZu',
        text: '瑶族',
        textPy: 'YZ',
        label: '瑶族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 13,
        name: 'BaiZu',
        text: '白族',
        textPy: 'BZ',
        label: '白族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 14,
        name: 'TuJiaZu',
        text: '土家族',
        textPy: 'TJZ',
        label: '土家族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 15,
        name: 'HaNiZu',
        text: '哈尼族',
        textPy: 'HNZ',
        label: '哈尼族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 16,
        name: 'HaSaKeZu',
        text: '哈萨克族',
        textPy: 'HSKZ',
        label: '哈萨克族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 17,
        name: 'DaiZu',
        text: '傣族',
        textPy: 'DZ',
        label: '傣族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 18,
        name: 'LiZu',
        text: '黎族',
        textPy: 'LZ',
        label: '黎族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 19,
        name: 'LiSuZu',
        text: '傈僳族',
        textPy: 'LSZ',
        label: '傈僳族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 20,
        name: 'WaZu',
        text: '佤族',
        textPy: 'WZ',
        label: '佤族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 21,
        name: 'SheZu',
        text: '畲族',
        textPy: 'SZ',
        label: '畲族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 22,
        name: 'GaoShanZu',
        text: '高山族',
        textPy: 'GSZ',
        label: '高山族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 23,
        name: 'LaHuZu',
        text: '拉祜族',
        textPy: 'LHZ',
        label: '拉祜族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 24,
        name: 'ShuiZu',
        text: '水族',
        textPy: 'SZ',
        label: '水族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 25,
        name: 'DongXiangZu',
        text: '东乡族',
        textPy: 'DXZ',
        label: '东乡族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 26,
        name: 'NaXiZu',
        text: '纳西族',
        textPy: 'NXZ',
        label: '纳西族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 27,
        name: 'JingPoZu',
        text: '景颇族',
        textPy: 'JPZ',
        label: '景颇族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 28,
        name: 'KeErKeZiZu',
        text: '柯尔克孜族',
        textPy: 'KEKZZ',
        label: '柯尔克孜族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 29,
        name: 'TuZu',
        text: '土族',
        textPy: 'TZ',
        label: '土族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 30,
        name: 'DaWoErZu',
        text: '达斡尔族',
        textPy: 'DWEZ',
        label: '达斡尔族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 31,
        name: 'MuLaoZu',
        text: '仫佬族',
        textPy: 'MLZ',
        label: '仫佬族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 32,
        name: 'QiangZu',
        text: '羌族',
        textPy: 'QZ',
        label: '羌族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 33,
        name: 'BuLangZu',
        text: '布朗族',
        textPy: 'BLZ',
        label: '布朗族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 34,
        name: 'SaLaZu',
        text: '撒拉族',
        textPy: 'SLZ',
        label: '撒拉族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 35,
        name: 'MaoNanZu',
        text: '毛难族',
        textPy: 'MNZ',
        label: '毛难族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 36,
        name: 'YiLaoZu',
        text: '仡佬族',
        textPy: 'YLZ',
        label: '仡佬族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 37,
        name: 'XiBoZu',
        text: '锡伯族',
        textPy: 'XBZ',
        label: '锡伯族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 38,
        name: 'AChangZu',
        text: '阿昌族',
        textPy: 'ACZ',
        label: '阿昌族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 39,
        name: 'PuMiZu',
        text: '普米族',
        textPy: 'PMZ',
        label: '普米族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 40,
        name: 'TaJiKeZu',
        text: '塔吉克族',
        textPy: 'TJKZ',
        label: '塔吉克族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 41,
        name: 'NuZu',
        text: '怒族',
        textPy: 'NZ',
        label: '怒族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 42,
        name: 'WuZiBieKeZu',
        text: '乌孜别克族',
        textPy: 'WZBKZ',
        label: '乌孜别克族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 43,
        name: 'ELuoSiZu',
        text: '俄罗斯族',
        textPy: 'ELSZ',
        label: '俄罗斯族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 44,
        name: 'EWenKeZu',
        text: '鄂温克族',
        textPy: 'EWKZ',
        label: '鄂温克族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 45,
        name: 'BengLongZu',
        text: '崩龙族',
        textPy: 'BLZ',
        label: '崩龙族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 46,
        name: 'BaoAnZu',
        text: '保安族',
        textPy: 'BAZ',
        label: '保安族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 47,
        name: 'YuGuZu',
        text: '裕固族',
        textPy: 'YGZ',
        label: '裕固族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 48,
        name: 'JingZu',
        text: '京族',
        textPy: 'JZ',
        label: '京族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 49,
        name: 'TaTaErZu',
        text: '塔塔尔族',
        textPy: 'TTEZ',
        label: '塔塔尔族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 50,
        name: 'DuLongZu',
        text: '独龙族',
        textPy: 'DLZ',
        label: '独龙族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 51,
        name: 'ELunChunZu',
        text: '鄂伦春族',
        textPy: 'ELCZ',
        label: '鄂伦春族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 52,
        name: 'HeZheZu',
        text: '赫哲族',
        textPy: 'HZZ',
        label: '赫哲族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 53,
        name: 'MenBaZu',
        text: '门巴族',
        textPy: 'MBZ',
        label: '门巴族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 54,
        name: 'LuoBaZu',
        text: '珞巴族',
        textPy: 'LBZ',
        label: '珞巴族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 55,
        name: 'JiNuoZu',
        text: '基诺族',
        textPy: 'JNZ',
        label: '基诺族',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 99,
        name: 'Others',
        text: '其它',
        textPy: 'QT',
        label: '其它',
        color: '',
        icon: '',
        meta: null
      }

    ], '民族', 'stars')
  }

  get HanZu () {
    return 0
  }

  get MengGuZu () {
    return 1
  }

  get HuiZu () {
    return 2
  }

  get ZangZu () {
    return 3
  }

  get WeiWuErZu () {
    return 4
  }

  get MiaoZu () {
    return 5
  }

  get YiZu () {
    return 6
  }

  get ZhuangZu () {
    return 7
  }

  get BuYiZu () {
    return 8
  }

  get ChaoXianZu () {
    return 9
  }

  get ManZu () {
    return 10
  }

  get DongZu () {
    return 11
  }

  get YaoZu () {
    return 12
  }

  get BaiZu () {
    return 13
  }

  get TuJiaZu () {
    return 14
  }

  get HaNiZu () {
    return 15
  }

  get HaSaKeZu () {
    return 16
  }

  get DaiZu () {
    return 17
  }

  get LiZu () {
    return 18
  }

  get LiSuZu () {
    return 19
  }

  get WaZu () {
    return 20
  }

  get SheZu () {
    return 21
  }

  get GaoShanZu () {
    return 22
  }

  get LaHuZu () {
    return 23
  }

  get ShuiZu () {
    return 24
  }

  get DongXiangZu () {
    return 25
  }

  get NaXiZu () {
    return 26
  }

  get JingPoZu () {
    return 27
  }

  get KeErKeZiZu () {
    return 28
  }

  get TuZu () {
    return 29
  }

  get DaWoErZu () {
    return 30
  }

  get MuLaoZu () {
    return 31
  }

  get QiangZu () {
    return 32
  }

  get BuLangZu () {
    return 33
  }

  get SaLaZu () {
    return 34
  }

  get MaoNanZu () {
    return 35
  }

  get YiLaoZu () {
    return 36
  }

  get XiBoZu () {
    return 37
  }

  get AChangZu () {
    return 38
  }

  get PuMiZu () {
    return 39
  }

  get TaJiKeZu () {
    return 40
  }

  get NuZu () {
    return 41
  }

  get WuZiBieKeZu () {
    return 42
  }

  get ELuoSiZu () {
    return 43
  }

  get EWenKeZu () {
    return 44
  }

  get BengLongZu () {
    return 45
  }

  get BaoAnZu () {
    return 46
  }

  get YuGuZu () {
    return 47
  }

  get JingZu () {
    return 48
  }

  get TaTaErZu () {
    return 49
  }

  get DuLongZu () {
    return 50
  }

  get ELunChunZu () {
    return 51
  }

  get HeZheZu () {
    return 52
  }

  get MenBaZu () {
    return 53
  }

  get LuoBaZu () {
    return 54
  }

  get JiNuoZu () {
    return 55
  }

  get Others () {
    return 99
  }
}

export const Nation = Object.freeze(new NationType())

class ConfigItemScopeType extends EnumType {
  constructor () {
    super([

      {
        value: 100,
        name: 'App',
        text: '应用',
        textPy: 'YY',
        label: '应用',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 200,
        name: 'TerminalGroup',
        text: '终端组',
        textPy: 'ZDZ',
        label: '终端组',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 300,
        name: 'UserGroup',
        text: '用户组',
        textPy: 'YHZ',
        label: '用户组',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 400,
        name: 'Terminal',
        text: '终端',
        textPy: 'ZD',
        label: '终端',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 500,
        name: 'User',
        text: '用户',
        textPy: 'YH',
        label: '用户',
        color: '',
        icon: '',
        meta: null
      }

    ], '配置项作用域', '')
  }

  get App () {
    return 100
  }

  get TerminalGroup () {
    return 200
  }

  get UserGroup () {
    return 300
  }

  get Terminal () {
    return 400
  }

  get User () {
    return 500
  }
}

export const ConfigItemScope = Object.freeze(new ConfigItemScopeType())

class ConfigItemDataTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'String',
        text: '字符串',
        textPy: 'ZFC',
        label: '字符串',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Integer',
        text: '整数',
        textPy: 'ZS',
        label: '整数',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Float',
        text: '浮点数',
        textPy: 'FDS',
        label: '浮点数',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'DateTime',
        text: '时间',
        textPy: 'SJ',
        label: '时间',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'Object',
        text: '对象',
        textPy: 'DX',
        label: '对象',
        color: '',
        icon: '',
        meta: null
      }

    ], '配置项数据类型', '')
  }

  get String () {
    return 0
  }

  get Integer () {
    return 1
  }

  get Float () {
    return 2
  }

  get DateTime () {
    return 3
  }

  get Object () {
    return 4
  }
}

export const ConfigItemDataType = Object.freeze(new ConfigItemDataTypeType())

class HealthStatusType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Perfect',
        text: '优',
        textPy: 'Y',
        label: '优',
        color: 'primary',
        icon: 'ion-sentiment_satisfied_alt',
        meta: null
      },

      {
        value: 1,
        name: 'Fine',
        text: '良',
        textPy: 'L',
        label: '良',
        color: 'green',
        icon: 'ion-sentiment_neutral',
        meta: null
      },

      {
        value: 2,
        name: 'General',
        text: '一般',
        textPy: 'YB',
        label: '一般',
        color: 'red',
        icon: 'ion-sentiment_very_dissatisfied',
        meta: null
      }

    ], '健康状况', 'wc')
  }

  get Perfect () {
    return 0
  }

  get Fine () {
    return 1
  }

  get General () {
    return 2
  }
}

export const HealthStatus = Object.freeze(new HealthStatusType())

class MaterialOperationTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Handover',
        text: '交接',
        textPy: 'JJ',
        label: '交接',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 9,
        name: 'Discard',
        text: '报废',
        textPy: 'BF',
        label: '报废',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 10,
        name: 'Destroy',
        text: '销毁',
        textPy: 'XH',
        label: '销毁',
        color: '',
        icon: '',
        meta: null
      }

    ], '原料操作类型', '')
  }

  get Handover () {
    return 0
  }

  get Discard () {
    return 9
  }

  get Destroy () {
    return 10
  }
}

export const MaterialOperationType = Object.freeze(new MaterialOperationTypeType())

class TestStateType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Undone',
        text: '待检',
        textPy: 'DJ',
        label: '待检',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Done',
        text: '未发布',
        textPy: 'WFB',
        label: '未发布',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Published',
        text: '已发布',
        textPy: 'YFB',
        label: '已发布',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'Archived',
        text: '已存档',
        textPy: 'YCD',
        label: '已存档',
        color: '',
        icon: '',
        meta: null
      }

    ], '检验结果', 'catching_pokemon')
  }

  get Undone () {
    return 0
  }

  get Done () {
    return 1
  }

  get Published () {
    return 2
  }

  get Archived () {
    return 3
  }
}

export const TestState = Object.freeze(new TestStateType())

class BloodTestStateType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Undone',
        text: '待审核',
        textPy: 'WSH',
        label: '待审核',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Published',
        text: '已审核',
        textPy: 'YSH',
        label: '已审核',
        color: '',
        icon: '',
        meta: null
      }

    ], '血液检验结果', 'catching_pokemon')
  }

  get Undone () {
    return 0
  }

  get Published () {
    return 2
  }
}

export const BloodTestState = Object.freeze(new BloodTestStateType())

class ExamineStateType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Done',
        text: '未审核',
        textPy: 'WSH',
        label: '未审核',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Published',
        text: '已审核',
        textPy: 'YSH',
        label: '已审核',
        color: '',
        icon: '',
        meta: null
      }

    ], '审核状态', 'catching_pokemon')
  }

  get Done () {
    return 0
  }

  get Published () {
    return 1
  }
}

export const ExamineState = Object.freeze(new ExamineStateType())

class TransfusionStateType extends EnumType {
  constructor () {
    super([

      {
        value: 1,
        name: 'Collected',
        text: '已采集',
        textPy: 'YCJ',
        label: '已采集',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Received',
        text: '已接收',
        textPy: 'YJS',
        label: '已接收',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'InTest',
        text: '检验中',
        textPy: 'JYZ',
        label: '检验中',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'Published',
        text: '已发布',
        textPy: 'YFB',
        label: '已发布',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 5,
        name: 'Printed',
        text: '已打印',
        textPy: 'YDY',
        label: '已打印',
        color: '',
        icon: '',
        meta: null
      }

    ], '样本检验结果', 'catching_pokemon')
  }

  get Collected () {
    return 1
  }

  get Received () {
    return 2
  }

  get InTest () {
    return 3
  }

  get Published () {
    return 4
  }

  get Printed () {
    return 5
  }
}

export const TransfusionState = Object.freeze(new TransfusionStateType())

class PubilshStateType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Done',
        text: '未发布',
        textPy: 'WFB',
        label: '未发布',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Published',
        text: '已发布',
        textPy: 'YFB',
        label: '已发布',
        color: '',
        icon: '',
        meta: null
      }

    ], '发布状态', 'catching_pokemon')
  }

  get Done () {
    return 0
  }

  get Published () {
    return 1
  }
}

export const PubilshState = Object.freeze(new PubilshStateType())

class PossFourPubilshStatesType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Undone',
        text: '未发布',
        textPy: 'WFB',
        label: '未发布',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Published',
        text: '已发布',
        textPy: 'YFB',
        label: '已发布',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 5,
        name: 'Recheck',
        text: '已复检',
        textPy: 'YFJ',
        label: '已复检',
        color: '',
        icon: '',
        meta: null
      }

    ], '传四发布状态', 'catching_pokemon')
  }

  get Undone () {
    return 0
  }

  get Published () {
    return 1
  }

  get Recheck () {
    return 5
  }
}

export const PossFourPubilshStates = Object.freeze(new PossFourPubilshStatesType())

class PossFourExamineStatesType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Undone',
        text: '未审核',
        textPy: 'WSH',
        label: '未审核',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Published',
        text: '已审核',
        textPy: 'YSH',
        label: '已审核',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 5,
        name: 'Recheck',
        text: '已复检',
        textPy: 'YFJ',
        label: '已复检',
        color: '',
        icon: '',
        meta: null
      }

    ], '传四审核状态', 'catching_pokemon')
  }

  get Undone () {
    return 0
  }

  get Published () {
    return 1
  }

  get Recheck () {
    return 5
  }
}

export const PossFourExamineStates = Object.freeze(new PossFourExamineStatesType())

class PossFourTestResultType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Unknown',
        text: '待检',
        textPy: '待检',
        label: '待检',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Positive',
        text: '+',
        textPy: '+',
        label: '+',
        color: '',
        icon: '',
        meta: {"labelStyle":"font-size: 2em"}
      },

      {
        value: 2,
        name: 'Negative',
        text: '-',
        textPy: '-',
        label: '-',
        color: '',
        icon: '',
        meta: {"labelStyle":"font-size: 2em"}
      },

      {
        value: 3,
        name: 'Undone',
        text: '不做',
        textPy: '不做',
        label: '不做',
        color: '',
        icon: '',
        meta: {"labelStyle":"font-size: 1em"}
      },

      {
        value: 10,
        name: 'NegativeAndPositive',
        text: '弱阳性',
        textPy: '弱阳性',
        label: '弱阳性',
        color: '',
        icon: '',
        meta: {"labelStyle":"font-size: 1em"}
      },

      {
        value: 11,
        name: 'IsConfirm',
        text: '建议确认',
        textPy: '建议确认',
        label: '建议确认',
        color: '',
        icon: '',
        meta: {"labelStyle":"font-size: 1em"}
      }

    ], '传四检验结果', 'bloodtype')
  }

  get Unknown () {
    return 0
  }

  get Positive () {
    return 1
  }

  get Negative () {
    return 2
  }

  get Undone () {
    return 3
  }

  get NegativeAndPositive () {
    return 10
  }

  get IsConfirm () {
    return 11
  }
}

export const PossFourTestResult = Object.freeze(new PossFourTestResultType())

class TransPossFourTestResultType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Unknown',
        text: '已抽待检',
        textPy: '已抽待检',
        label: '已抽待检',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Positive',
        text: '+',
        textPy: '+',
        label: '+',
        color: '',
        icon: '',
        meta: {"labelStyle":"font-size: 2em"}
      },

      {
        value: 2,
        name: 'Negative',
        text: '-',
        textPy: '-',
        label: '-',
        color: '',
        icon: '',
        meta: {"labelStyle":"font-size: 2em"}
      },

      {
        value: 3,
        name: 'Undone',
        text: '未做',
        textPy: '未做',
        label: '未做',
        color: '',
        icon: '',
        meta: {"labelStyle":"font-size: 1em"}
      }

    ], '传四检验结果', 'bloodtype')
  }

  get Unknown () {
    return 0
  }

  get Positive () {
    return 1
  }

  get Negative () {
    return 2
  }

  get Undone () {
    return 3
  }
}

export const TransPossFourTestResult = Object.freeze(new TransPossFourTestResultType())

class DisplayTestStateType extends EnumType {
  constructor () {
    super([

      {
        value: 2801,
        name: 'Unpublish',
        text: '未发布',
        textPy: 'WFB',
        label: '未发布',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2802,
        name: 'Published',
        text: '已发布',
        textPy: 'YFB',
        label: '已发布',
        color: '',
        icon: '',
        meta: null
      }

    ], '检验结果', 'catching_pokemon')
  }

  get Unpublish () {
    return 2801
  }

  get Published () {
    return 2802
  }
}

export const DisplayTestState = Object.freeze(new DisplayTestStateType())

class TestResultTypesType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'WaitInspect',
        text: '待检',
        textPy: 'DJ',
        label: '待检',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'OkInspect',
        text: '已检',
        textPy: 'YJ',
        label: '已检',
        color: '',
        icon: '',
        meta: null
      }

    ], '检验结果', 'catching_pokemon')
  }

  get WaitInspect () {
    return 0
  }

  get OkInspect () {
    return 1
  }
}

export const TestResultTypes = Object.freeze(new TestResultTypesType())

class ComponentMaterialFlagType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'None',
        text: '无',
        textPy: '无',
        label: '无',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'WholeBlood',
        text: '全血',
        textPy: '全血',
        label: '全血',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'PheresisPlatelets',
        text: '单采血小板',
        textPy: '单采血小板',
        label: '单采血小板',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'PheresisPlasma',
        text: '单采血浆',
        textPy: '单采血浆',
        label: '单采血浆',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'CovidPlasma',
        text: '新冠恢复期血浆',
        textPy: '新冠恢复期血浆',
        label: '新冠恢复期血浆',
        color: '',
        icon: '',
        meta: null
      }

    ], '成分原料标识', '')
  }

  get None () {
    return 0
  }

  get WholeBlood () {
    return 1
  }

  get PheresisPlatelets () {
    return 2
  }

  get PheresisPlasma () {
    return 3
  }

  get CovidPlasma () {
    return 4
  }
}

export const ComponentMaterialFlag = Object.freeze(new ComponentMaterialFlagType())

class ComponentSemiprodFlagType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'None',
        text: '无',
        textPy: '无',
        label: '无',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'MaterialProcessed',
        text: '原料制备半成品',
        textPy: '原料制备半成品',
        label: '原料制备半成品',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Pheresis',
        text: '采集即半成品',
        textPy: '采集即半成品',
        label: '采集即半成品',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'Material',
        text: '原料直接成半成品',
        textPy: '原料直接成半成品',
        label: '原料直接成半成品',
        color: '',
        icon: '',
        meta: null
      }

    ], '成分半成品标识', '')
  }

  get None () {
    return 0
  }

  get MaterialProcessed () {
    return 1
  }

  get Pheresis () {
    return 2
  }

  get Material () {
    return 3
  }
}

export const ComponentSemiprodFlag = Object.freeze(new ComponentSemiprodFlagType())

class ComponentOperationFlagType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'None',
        text: '无',
        textPy: '无',
        label: '无',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'MaterialHandover',
        text: '原料交接',
        textPy: '原料交接',
        label: '原料交接',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'SemiprodCheck',
        text: '半成品核查',
        textPy: '半成品核查',
        label: '半成品核查',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'ProductStockInCheck',
        text: '成品入库核查',
        textPy: '成品入库核查',
        label: '成品入库核查',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 8,
        name: 'ProductStockOutCheck',
        text: '成品出库核查',
        textPy: '成品出库核查',
        label: '成品出库核查',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 16,
        name: 'TransfusionSelf',
        text: '自身输血',
        textPy: '自身输血',
        label: '自身输血',
        color: '',
        icon: '',
        meta: null
      }

    ], '成分操作标识', '')
  }

  get None () {
    return 0
  }

  get MaterialHandover () {
    return 1
  }

  get SemiprodCheck () {
    return 2
  }

  get ProductStockInCheck () {
    return 4
  }

  get ProductStockOutCheck () {
    return 8
  }

  get TransfusionSelf () {
    return 16
  }
}

export const ComponentOperationFlag = Object.freeze(new ComponentOperationFlagType())

class ComponentExpireStartType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'CollectTime',
        text: '采血时间',
        textPy: '采血时间',
        label: '采血时间',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'ProductionTime',
        text: '制备时间',
        textPy: '制备时间',
        label: '制备时间',
        color: '',
        icon: '',
        meta: null
      }

    ], '成分失效期起始时间', '')
  }

  get CollectTime () {
    return 0
  }

  get ProductionTime () {
    return 1
  }
}

export const ComponentExpireStart = Object.freeze(new ComponentExpireStartType())

class DonatorFilterType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'PheresisAvailable',
        text: '单采满14天',
        textPy: '单采满14天',
        label: '单采满14天',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'WholeBloodAvailable',
        text: '全血满183天',
        textPy: '全血满183天',
        label: '全血满183天',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'WholeBloodToPheresis',
        text: '全血转血小板满90天',
        textPy: '全血转血小板满90天',
        label: '全血转血小板满90天',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'PheresisToWholeBlood',
        text: '血小板转全血满30天',
        textPy: '血小板转全血满30天',
        label: '血小板转全血满30天',
        color: '',
        icon: '',
        meta: null
      }

    ], '献血者过滤条件', 'filter_alt')
  }

  get PheresisAvailable () {
    return 0
  }

  get WholeBloodAvailable () {
    return 1
  }

  get WholeBloodToPheresis () {
    return 2
  }

  get PheresisToWholeBlood () {
    return 3
  }
}

export const DonatorFilter = Object.freeze(new DonatorFilterType())

class TestItemTokenType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'T',
        text: 'TP-梅毒',
        textPy: 'MD',
        label: 'TP-梅毒',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'I',
        text: 'HIV-艾滋',
        textPy: 'AZ',
        label: 'HIV-艾滋',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'C',
        text: 'HCV-丙肝',
        textPy: 'BG',
        label: 'HCV-丙肝',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'B',
        text: 'HBV-乙肝',
        textPy: 'YG',
        label: 'HBV-乙肝',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'A',
        text: 'ALT-转氨酶',
        textPy: 'ZAM',
        label: 'ALT-转氨酶',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 5,
        name: 'Z',
        text: '正定型+Rh(D)',
        textPy: 'ZDX',
        label: '正定型+Rh(D)',
        color: '',
        icon: '',
        meta: null
      }

    ], '检验项目符号', 'coronavirus')
  }

  get T () {
    return 0
  }

  get I () {
    return 1
  }

  get C () {
    return 2
  }

  get B () {
    return 3
  }

  get A () {
    return 4
  }

  get Z () {
    return 5
  }
}

export const TestItemToken = Object.freeze(new TestItemTokenType())

class PossFourTestItemTokenType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'T',
        text: 'TP-梅毒',
        textPy: 'MD',
        label: 'TP-梅毒',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'I',
        text: 'HIV-艾滋',
        textPy: 'AZ',
        label: 'HIV-艾滋',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'C',
        text: 'HCV-丙肝',
        textPy: 'BG',
        label: 'HCV-丙肝',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'B',
        text: 'HBV-乙肝',
        textPy: 'YG',
        label: 'HBV-乙肝',
        color: '',
        icon: '',
        meta: null
      }

    ], '传四检验项目符号', 'coronavirus')
  }

  get T () {
    return 0
  }

  get I () {
    return 1
  }

  get C () {
    return 2
  }

  get B () {
    return 3
  }
}

export const PossFourTestItemToken = Object.freeze(new PossFourTestItemTokenType())

class TestNucleicAcidItemTokenType extends EnumType {
  constructor () {
    super([

      {
        value: 1,
        name: 'I',
        text: 'HIV-艾滋',
        textPy: 'AZ',
        label: 'HIV-艾滋',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'C',
        text: 'HCV-丙肝',
        textPy: 'BG',
        label: 'HCV-丙肝',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'B',
        text: 'HBV-乙肝',
        textPy: 'YG',
        label: 'HBV-乙肝',
        color: '',
        icon: '',
        meta: null
      }

    ], '检验项目', 'coronavirus')
  }

  get I () {
    return 1
  }

  get C () {
    return 2
  }

  get B () {
    return 3
  }
}

export const TestNucleicAcidItemToken = Object.freeze(new TestNucleicAcidItemTokenType())

class TestItemShortType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'TP',
        text: 'TP-梅毒',
        textPy: 'MD',
        label: 'TP-梅毒',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'HIV',
        text: 'HIV-艾滋',
        textPy: 'AZ',
        label: 'HIV-艾滋',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'HCV',
        text: 'HCV-丙肝',
        textPy: 'BG',
        label: 'HCV-丙肝',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'HBV',
        text: 'HBV-乙肝',
        textPy: 'YG',
        label: 'HBV-乙肝',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'ALT',
        text: 'ALT-转氨酶',
        textPy: 'ZAM',
        label: 'ALT-转氨酶',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 5,
        name: 'Z',
        text: '正定型+Rh(D)',
        textPy: 'ZDX',
        label: '正定型+Rh(D)',
        color: '',
        icon: '',
        meta: null
      }

    ], '检验项目缩写', 'coronavirus')
  }

  get TP () {
    return 0
  }

  get HIV () {
    return 1
  }

  get HCV () {
    return 2
  }

  get HBV () {
    return 3
  }

  get ALT () {
    return 4
  }

  get Z () {
    return 5
  }
}

export const TestItemShort = Object.freeze(new TestItemShortType())

class TestDeviceType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'AK',
        text: '爱康',
        textPy: 'AK',
        label: '爱康',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'FM',
        text: '费米',
        textPy: 'FM',
        label: '费米',
        color: '',
        icon: '',
        meta: null
      }

    ], '检验设备', 'scanner')
  }

  get AK () {
    return 0
  }

  get FM () {
    return 1
  }
}

export const TestDevice = Object.freeze(new TestDeviceType())

class InstrumentTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 1,
        name: 'AT',
        text: '安图',
        textPy: 'AT',
        label: '安图',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'MR',
        text: '迈瑞',
        textPy: 'MR',
        label: '迈瑞',
        color: '',
        icon: '',
        meta: null
      }

    ], '仪器列表', 'scanner')
  }

  get AT () {
    return 1
  }

  get MR () {
    return 2
  }
}

export const InstrumentType = Object.freeze(new InstrumentTypeType())

class TestNucleicAcidDeviceType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'DA',
        text: '达安',
        textPy: 'DA',
        label: '达安',
        color: '',
        icon: '',
        meta: null
      }

    ], '核酸检验设备', 'scanner')
  }

  get DA () {
    return 0
  }
}

export const TestNucleicAcidDevice = Object.freeze(new TestNucleicAcidDeviceType())

class FourInfectiousDiseaseDeviceType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'FM',
        text: '费米',
        textPy: 'FM',
        label: '费米',
        color: '',
        icon: '',
        meta: null
      }

    ], '传四检验设备', 'scanner')
  }

  get FM () {
    return 0
  }
}

export const FourInfectiousDiseaseDevice = Object.freeze(new FourInfectiousDiseaseDeviceType())

class DateRangeType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Day',
        text: '今天',
        textPy: 'JT',
        label: '今天',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Month',
        text: '本月',
        textPy: 'BY',
        label: '本月',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'LastMonth',
        text: '上月',
        textPy: 'SY',
        label: '上月',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'Year',
        text: '本年',
        textPy: 'BN',
        label: '本年',
        color: '',
        icon: '',
        meta: null
      }

    ], '时间段', 'hourglass_top')
  }

  get Day () {
    return 0
  }

  get Month () {
    return 1
  }

  get LastMonth () {
    return 2
  }

  get Year () {
    return 3
  }
}

export const DateRange = Object.freeze(new DateRangeType())

class DateRange2Type extends EnumType {
  constructor () {
    super([

      {
        value: 1,
        name: 'Week',
        text: '本周',
        textPy: 'BZ',
        label: '本周',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Month',
        text: '本月',
        textPy: 'BY',
        label: '本月',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'LastMonth',
        text: '上月',
        textPy: 'SY',
        label: '上月',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'Quarter',
        text: '本季度',
        textPy: 'BJD',
        label: '本季度',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 5,
        name: 'LastQuarter',
        text: '上季度',
        textPy: 'BJD',
        label: '上季度',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 6,
        name: 'Year',
        text: '本年',
        textPy: 'SN',
        label: '本年',
        color: '',
        icon: '',
        meta: null
      }

    ], '时间段', 'hourglass_top')
  }

  get Week () {
    return 1
  }

  get Month () {
    return 2
  }

  get LastMonth () {
    return 3
  }

  get Quarter () {
    return 4
  }

  get LastQuarter () {
    return 5
  }

  get Year () {
    return 6
  }
}

export const DateRange2 = Object.freeze(new DateRange2Type())

class DateRange3Type extends EnumType {
  constructor () {
    super([

      {
        value: 2,
        name: 'Month',
        text: '本月',
        textPy: 'BY',
        label: '本月',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'LastMonth',
        text: '上月',
        textPy: 'SY',
        label: '上月',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'Quarter',
        text: '本季度',
        textPy: 'BJD',
        label: '本季度',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 5,
        name: 'LastQuarter',
        text: '上季度',
        textPy: 'BJD',
        label: '上季度',
        color: '',
        icon: '',
        meta: null
      }

    ], '时间段', 'hourglass_top')
  }

  get Month () {
    return 2
  }

  get LastMonth () {
    return 3
  }

  get Quarter () {
    return 4
  }

  get LastQuarter () {
    return 5
  }
}

export const DateRange3 = Object.freeze(new DateRange3Type())

class DateRange4Type extends EnumType {
  constructor () {
    super([

      {
        value: 2,
        name: 'Month',
        text: '本月',
        textPy: 'BY',
        label: '本月',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'LastMonth',
        text: '上月',
        textPy: 'SY',
        label: '上月',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'Quarter',
        text: '本季度',
        textPy: 'BJD',
        label: '本季度',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 5,
        name: 'LastQuarter',
        text: '上季度',
        textPy: 'BJD',
        label: '上季度',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 6,
        name: 'Year',
        text: '本年',
        textPy: 'SN',
        label: '本年',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 7,
        name: 'LastYear',
        text: '上年',
        textPy: 'SN',
        label: '上年',
        color: '',
        icon: '',
        meta: null
      }

    ], '时间段', 'hourglass_top')
  }

  get Month () {
    return 2
  }

  get LastMonth () {
    return 3
  }

  get Quarter () {
    return 4
  }

  get LastQuarter () {
    return 5
  }

  get Year () {
    return 6
  }

  get LastYear () {
    return 7
  }
}

export const DateRange4 = Object.freeze(new DateRange4Type())

class GroupTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 1,
        name: 'BloodDonation',
        text: '献血屋',
        textPy: 'XXW',
        label: '献血屋',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'BloodGroup',
        text: '血型组',
        textPy: 'XXZ',
        label: '血型组',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'FourInfectious',
        text: '传四组',
        textPy: 'CSZ',
        label: '传四组',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'Issue',
        text: '配发组',
        textPy: 'PFZ',
        label: '配发组',
        color: '',
        icon: '',
        meta: null
      }

    ], '组别', 'hourglass_top')
  }

  get BloodDonation () {
    return 1
  }

  get BloodGroup () {
    return 2
  }

  get FourInfectious () {
    return 3
  }

  get Issue () {
    return 4
  }
}

export const GroupType = Object.freeze(new GroupTypeType())

class MaterialStateType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'UnCollected',
        text: '未采集',
        textPy: '未采集',
        label: '未采集',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Collected',
        text: '已采集',
        textPy: '已采集',
        label: '已采集',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Handover',
        text: '已交接',
        textPy: '已交接',
        label: '已交接',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'Consumed',
        text: '已制备',
        textPy: '已制备',
        label: '已制备',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 9,
        name: 'Discard',
        text: '已报废',
        textPy: '已报废',
        label: '已报废',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 10,
        name: 'Destroyed',
        text: '已销毁',
        textPy: '已销毁',
        label: '已销毁',
        color: '',
        icon: '',
        meta: null
      }

    ], '原料状态', '')
  }

  get UnCollected () {
    return 0
  }

  get Collected () {
    return 1
  }

  get Handover () {
    return 2
  }

  get Consumed () {
    return 3
  }

  get Discard () {
    return 9
  }

  get Destroyed () {
    return 10
  }
}

export const MaterialState = Object.freeze(new MaterialStateType())

class SpecimenHandoverOperationTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 1,
        name: 'Send',
        text: '标本送交',
        textPy: '标本送交',
        label: '标本送交',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Receive',
        text: '标本接收',
        textPy: '标本接收',
        label: '标本接收',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'Handover',
        text: '标本交接',
        textPy: '标本交接',
        label: '标本交接',
        color: '',
        icon: '',
        meta: null
      }

    ], '标本交接操作类型', '')
  }

  get Send () {
    return 1
  }

  get Receive () {
    return 2
  }

  get Handover () {
    return 3
  }
}

export const SpecimenHandoverOperationType = Object.freeze(new SpecimenHandoverOperationTypeType())

class SemiprodStateType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Produced',
        text: '已制备',
        textPy: '已制备',
        label: '已制备',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Consumed',
        text: '已消耗',
        textPy: '已消耗',
        label: '已消耗',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Checked',
        text: '已核查',
        textPy: '已核查',
        label: '已核查',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'Released',
        text: '已放行',
        textPy: '已放行',
        label: '已放行',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 8,
        name: 'DiscardInProduce',
        text: '制备中报废',
        textPy: '制备中报废',
        label: '制备中报废',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 9,
        name: 'Discard',
        text: '已报废',
        textPy: '已报废',
        label: '已报废',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 10,
        name: 'Destroyed',
        text: '已销毁',
        textPy: '已销毁',
        label: '已销毁',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 11,
        name: 'Destroyeded',
        text: '销毁后已放行',
        textPy: '销毁后已放行',
        label: '销毁后已放行',
        color: '',
        icon: '',
        meta: null
      }

    ], '半成品状态', '')
  }

  get Produced () {
    return 0
  }

  get Consumed () {
    return 1
  }

  get Checked () {
    return 2
  }

  get Released () {
    return 3
  }

  get DiscardInProduce () {
    return 8
  }

  get Discard () {
    return 9
  }

  get Destroyed () {
    return 10
  }

  get Destroyeded () {
    return 11
  }
}

export const SemiprodState = Object.freeze(new SemiprodStateType())

class ProdStateType extends EnumType {
  constructor () {
    super([

      {
        value: 9,
        name: 'Asc',
        text: '已报废',
        textPy: '已报废',
        label: '已报废',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 10,
        name: 'Desc',
        text: '已销毁',
        textPy: '已销毁',
        label: '已销毁',
        color: '',
        icon: '',
        meta: null
      }

    ], '状态', '')
  }

  get Asc () {
    return 9
  }

  get Desc () {
    return 10
  }
}

export const ProdState = Object.freeze(new ProdStateType())

class SemiprodOperationTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Check',
        text: '待检库核查',
        textPy: '待检库核查',
        label: '待检库核查',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Release',
        text: '待检库放行',
        textPy: '待检库放行',
        label: '待检库放行',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 9,
        name: 'Discard',
        text: '报废',
        textPy: '报废',
        label: '报废',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 10,
        name: 'Destroy',
        text: '销毁',
        textPy: '销毁',
        label: '销毁',
        color: '',
        icon: '',
        meta: null
      }

    ], '半成品操作', '')
  }

  get Check () {
    return 0
  }

  get Release () {
    return 1
  }

  get Discard () {
    return 9
  }

  get Destroy () {
    return 10
  }
}

export const SemiprodOperationType = Object.freeze(new SemiprodOperationTypeType())

class CheckStateType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'UnPass',
        text: '核查未通过',
        textPy: '核查未通过',
        label: '核查未通过',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'None',
        text: '待核查',
        textPy: '待核查',
        label: '待核查',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Pass',
        text: '核查通过',
        textPy: '核查通过',
        label: '核查通过',
        color: '',
        icon: '',
        meta: null
      }

    ], '核查状态', '')
  }

  get UnPass () {
    return 0
  }

  get None () {
    return 1
  }

  get Pass () {
    return 2
  }
}

export const CheckState = Object.freeze(new CheckStateType())

class ProductOperationTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'StockInCheck',
        text: '成品入库核查',
        textPy: '成品入库核查',
        label: '成品入库核查',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'StockIn',
        text: '成品入库',
        textPy: '成品入库',
        label: '成品入库',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'StockOutCheck',
        text: '成品出库核查',
        textPy: '成品出库核查',
        label: '成品出库核查',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'StockOut',
        text: '本院用血',
        textPy: '本院用血',
        label: '本院用血',
        color: '',
        icon: '',
        meta: {"stockOut":1}
      },

      {
        value: 4,
        name: 'ForeignStorageIn',
        text: '外来血入库',
        textPy: '外来血入库',
        label: '外来血入库',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 5,
        name: 'ForeignFile',
        text: '外来血液归档',
        textPy: '外来血液归档',
        label: '外来血液归档',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 6,
        name: 'StockOutReprocess',
        text: '库血再制',
        textPy: '库血再制',
        label: '库血再制',
        color: '',
        icon: '',
        meta: {"stockOut":1}
      },

      {
        value: 7,
        name: 'StockInReprocess',
        text: '库血再制入库',
        textPy: '库血再制入库',
        label: '库血再制入库',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 8,
        name: 'TransfusionSelfStorageIn',
        text: '自身输血待入库',
        textPy: '自身输血待入库',
        label: '自身输血待入库',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 9,
        name: 'Discard',
        text: '成品报废',
        textPy: '成品报废',
        label: '成品报废',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 10,
        name: 'Destroy',
        text: '成品销毁',
        textPy: '成品销毁',
        label: '成品销毁',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 11,
        name: 'TransfusionSelfStorageOut',
        text: '自身输血出库',
        textPy: '自身输血出库',
        label: '自身输血出库',
        color: '',
        icon: '',
        meta: {"stockOut":1}
      },

      {
        value: 12,
        name: 'ForeignStorageOut',
        text: '单位用血',
        textPy: '单位用血',
        label: '单位用血',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 13,
        name: 'ReturnBack',
        text: '成品退回',
        textPy: '成品退回',
        label: '成品退回',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 14,
        name: 'SpecialOut',
        text: '特殊出库',
        textPy: '特殊出库',
        label: '特殊出库',
        color: '',
        icon: '',
        meta: {"stockOut":1}
      },

      {
        value: 15,
        name: 'GreenChannelOut',
        text: '绿色通道',
        textPy: '绿色通道',
        label: '绿色通道',
        color: '',
        icon: '',
        meta: {"stockOut":1}
      },

      {
        value: 44,
        name: 'Delete',
        text: '删除',
        textPy: '删除',
        label: '删除',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 47,
        name: 'CombatLibraryIn',
        text: '战备库入库',
        textPy: '战备库入库',
        label: '战备库入库',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 48,
        name: 'CombatLibraryOut',
        text: '战备库出库',
        textPy: '战备库出库',
        label: '战备库出库',
        color: '',
        icon: '',
        meta: null
      }

    ], '成品操作类型', '')
  }

  get StockInCheck () {
    return 0
  }

  get StockIn () {
    return 1
  }

  get StockOutCheck () {
    return 2
  }

  get StockOut () {
    return 3
  }

  get ForeignStorageIn () {
    return 4
  }

  get ForeignFile () {
    return 5
  }

  get StockOutReprocess () {
    return 6
  }

  get StockInReprocess () {
    return 7
  }

  get TransfusionSelfStorageIn () {
    return 8
  }

  get Discard () {
    return 9
  }

  get Destroy () {
    return 10
  }

  get TransfusionSelfStorageOut () {
    return 11
  }

  get ForeignStorageOut () {
    return 12
  }

  get ReturnBack () {
    return 13
  }

  get SpecialOut () {
    return 14
  }

  get GreenChannelOut () {
    return 15
  }

  get Delete () {
    return 44
  }

  get CombatLibraryIn () {
    return 47
  }

  get CombatLibraryOut () {
    return 48
  }
}

export const ProductOperationType = Object.freeze(new ProductOperationTypeType())

class PromptLevelType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Info',
        text: '信息',
        textPy: 'XX',
        label: '信息',
        color: 'info',
        icon: 'info',
        meta: null
      },

      {
        value: 1,
        name: 'Success',
        text: '成功',
        textPy: 'CG',
        label: '成功',
        color: 'positive',
        icon: 'check_circle',
        meta: null
      },

      {
        value: 2,
        name: 'Warn',
        text: '警告',
        textPy: 'JG',
        label: '警告',
        color: 'warning',
        icon: 'warning',
        meta: null
      },

      {
        value: 3,
        name: 'Error',
        text: '错误',
        textPy: 'CW',
        label: '错误',
        color: 'negative',
        icon: 'error',
        meta: null
      }

    ], '提示等级', '')
  }

  get Info () {
    return 0
  }

  get Success () {
    return 1
  }

  get Warn () {
    return 2
  }

  get Error () {
    return 3
  }
}

export const PromptLevel = Object.freeze(new PromptLevelType())

class IcfStateType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Unsigned',
        text: '未签署',
        textPy: 'WQS',
        label: '未签署',
        color: 'negative',
        icon: 'highlight_off',
        meta: null
      },

      {
        value: 1,
        name: 'Signed',
        text: '已签署',
        textPy: 'YQS',
        label: '已签署',
        color: 'positive',
        icon: 'check_circle_outline',
        meta: null
      },

      {
        value: 2,
        name: 'Emergency',
        text: '急诊',
        textPy: 'JZ',
        label: '急诊',
        color: 'red',
        icon: 'medical_services',
        meta: null
      }

    ], '知情同意书', 'receipt_long')
  }

  get Unsigned () {
    return 0
  }

  get Signed () {
    return 1
  }

  get Emergency () {
    return 2
  }
}

export const IcfState = Object.freeze(new IcfStateType())

class PatientOriginType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'His',
        text: 'HIS',
        textPy: 'HIS',
        label: 'HIS',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Bis',
        text: 'BIS',
        textPy: 'BIS',
        label: 'BIS',
        color: '',
        icon: '',
        meta: null
      }

    ], '患者信息来源', 'trip_origin')
  }

  get His () {
    return 0
  }

  get Bis () {
    return 1
  }
}

export const PatientOrigin = Object.freeze(new PatientOriginType())

class IfiType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Irradiation',
        text: '辐照',
        textPy: 'FZ',
        label: '辐照',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Filter',
        text: '过滤',
        textPy: 'GL',
        label: '过滤',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Inactivation',
        text: '灭活',
        textPy: 'MH',
        label: '灭活',
        color: '',
        icon: '',
        meta: null
      }

    ], '辐照过滤灭活', '')
  }

  get Irradiation () {
    return 0
  }

  get Filter () {
    return 1
  }

  get Inactivation () {
    return 2
  }
}

export const Ifi = Object.freeze(new IfiType())

class FeeIfiType extends EnumType {
  constructor () {
    super([

      {
        value: 2,
        name: 'Empty',
        text: '无',
        textPy: 'W',
        label: '无',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 0,
        name: 'Irradiation',
        text: '辐照',
        textPy: 'FZ',
        label: '辐照',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Filter',
        text: '过滤',
        textPy: 'GL',
        label: '过滤',
        color: '',
        icon: '',
        meta: null
      }

    ], '无辐照过滤', '')
  }

  get Empty () {
    return 2
  }

  get Irradiation () {
    return 0
  }

  get Filter () {
    return 1
  }
}

export const FeeIfi = Object.freeze(new FeeIfiType())

class ReagentStateType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Enabled',
        text: '正常',
        textPy: 'QY',
        label: '正常',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Disabled',
        text: '停用',
        textPy: 'TY',
        label: '停用',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Wait',
        text: '待启用',
        textPy: 'DQY',
        label: '待启用',
        color: '',
        icon: '',
        meta: null
      }

    ], '试剂状态', 'settings')
  }

  get Enabled () {
    return 0
  }

  get Disabled () {
    return 1
  }

  get Wait () {
    return 2
  }
}

export const ReagentState = Object.freeze(new ReagentStateType())

class UserStatusType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Disabled',
        text: '禁用',
        textPy: 'JY',
        label: '禁用',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Enabled',
        text: '启用',
        textPy: 'QY',
        label: '启用',
        color: '',
        icon: '',
        meta: null
      }

    ], '用户状态', 'manage_accounts')
  }

  get Disabled () {
    return 0
  }

  get Enabled () {
    return 1
  }
}

export const UserStatus = Object.freeze(new UserStatusType())

class RoleStatusType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Enabled',
        text: '禁用',
        textPy: 'JY',
        label: '禁用',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Disabled',
        text: '启用',
        textPy: 'QY',
        label: '启用',
        color: '',
        icon: '',
        meta: null
      }

    ], '权限状态', 'manage_accounts')
  }

  get Enabled () {
    return 0
  }

  get Disabled () {
    return 1
  }
}

export const RoleStatus = Object.freeze(new RoleStatusType())

class RoleDataScopeType extends EnumType {
  constructor () {
    super([

      {
        value: 1,
        name: 'AllData',
        text: '所有数据权限',
        textPy: 'SYSJ',
        label: '所有数据权限',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'CustomData',
        text: '自定义数据权限',
        textPy: 'ZDYSJ',
        label: '自定义数据权限',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'DeptData',
        text: '本部门数据权限',
        textPy: 'BBMSJ',
        label: '本部门数据权限',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'DeptDownData',
        text: '本部门及以下数据权限',
        textPy: 'BBMJYXSJ',
        label: '本部门及以下数据权限',
        color: '',
        icon: '',
        meta: null
      }

    ], '权限数据范围', '')
  }

  get AllData () {
    return 1
  }

  get CustomData () {
    return 2
  }

  get DeptData () {
    return 3
  }

  get DeptDownData () {
    return 4
  }
}

export const RoleDataScope = Object.freeze(new RoleDataScopeType())

class ReagentTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Normal',
        text: '普通试剂',
        textPy: 'PTSJ',
        label: '普通试剂',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Qc',
        text: '质控物',
        textPy: 'ZKW',
        label: '质控物',
        color: '',
        icon: '',
        meta: null
      }

    ], '试剂类型', 'format_size')
  }

  get Normal () {
    return 0
  }

  get Qc () {
    return 1
  }
}

export const ReagentType = Object.freeze(new ReagentTypeType())

class SpecimenTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'BloodTube',
        text: '标本',
        textPy: 'SGXY',
        label: '标本',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'BloodCatheter',
        text: '小辫',
        textPy: 'XBXY',
        label: '小辫',
        color: '',
        icon: '',
        meta: null
      }

    ], '样本类型', 'local_drink')
  }

  get BloodTube () {
    return 0
  }

  get BloodCatheter () {
    return 1
  }
}

export const SpecimenType = Object.freeze(new SpecimenTypeType())

class SpecimenStateType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Collected',
        text: '已采集',
        textPy: 'YCJ',
        label: '已采集',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Sent',
        text: '已送交',
        textPy: 'YSJ',
        label: '已送交',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Handover',
        text: '已交接',
        textPy: 'YJJ',
        label: '已交接',
        color: '',
        icon: '',
        meta: null
      }

    ], '样本状态', 'local_drink')
  }

  get Collected () {
    return 0
  }

  get Sent () {
    return 1
  }

  get Handover () {
    return 2
  }
}

export const SpecimenState = Object.freeze(new SpecimenStateType())

class TransfusionSelfStateType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Reserved',
        text: '预留',
        textPy: 'YL',
        label: '预留',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Collected',
        text: '已采集',
        textPy: 'YCJ',
        label: '已采集',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Consumed',
        text: '已回输',
        textPy: 'YHS',
        label: '已回输',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'Convert',
        text: '已转献血',
        textPy: 'YZXX',
        label: '已转献血',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 9,
        name: 'Discard',
        text: '已报废',
        textPy: 'YBF',
        label: '已报废',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 10,
        name: 'Destoryed',
        text: '已销毁',
        textPy: 'YXH',
        label: '已销毁',
        color: '',
        icon: '',
        meta: null
      }

    ], '自身输血状态', '')
  }

  get Reserved () {
    return 0
  }

  get Collected () {
    return 1
  }

  get Consumed () {
    return 2
  }

  get Convert () {
    return 4
  }

  get Discard () {
    return 9
  }

  get Destoryed () {
    return 10
  }
}

export const TransfusionSelfState = Object.freeze(new TransfusionSelfStateType())

class TransfusionalPriorityType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Normal',
        text: '正常',
        textPy: 'ZC',
        label: '正常',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'High',
        text: '优先用血',
        textPy: 'YXYX',
        label: '优先用血',
        color: '',
        icon: '',
        meta: null
      }

    ], '优先用血级别', '')
  }

  get Normal () {
    return 0
  }

  get High () {
    return 1
  }
}

export const TransfusionalPriority = Object.freeze(new TransfusionalPriorityType())

class InstrumentFileStateType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Loaded',
        text: '已加载',
        textPy: 'YJZ',
        label: '已加载',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'ModelSaved',
        text: '模型已保存',
        textPy: 'MXYBC',
        label: '模型已保存',
        color: '',
        icon: '',
        meta: null
      }

    ], '仪器文件状态', '')
  }

  get Loaded () {
    return 0
  }

  get ModelSaved () {
    return 1
  }
}

export const InstrumentFileState = Object.freeze(new InstrumentFileStateType())

class InstrumentUsageType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Test',
        text: '检验',
        textPy: 'JY',
        label: '检验',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Match',
        text: '自动配血',
        textPy: 'ZDPX',
        label: '自动配血',
        color: '',
        icon: '',
        meta: null
      }

    ], '仪器用途', '')
  }

  get Test () {
    return 0
  }

  get Match () {
    return 1
  }
}

export const InstrumentUsage = Object.freeze(new InstrumentUsageType())

class BizOperationType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'None',
        text: '无',
        textPy: 'W',
        label: '无',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'QueryStorageUnchecked',
        text: '待检库库存',
        textPy: 'DJKKC',
        label: '待检库库存',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'QueryStorageChecked',
        text: '成品库库存',
        textPy: 'CPKKC',
        label: '成品库库存',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'InBox',
        text: '入箱',
        textPy: 'RX',
        label: '入箱',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'OutBox',
        text: '出箱',
        textPy: 'CX',
        label: '出箱',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 5,
        name: 'OutStorage',
        text: '出库',
        textPy: 'CK',
        label: '出库',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 6,
        name: 'CheckStorage',
        text: '盘库',
        textPy: 'PK',
        label: '盘库',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 7,
        name: 'CentrifugationBegin',
        text: '开始离心',
        textPy: 'KSLX',
        label: '开始离心',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 8,
        name: 'CentrifugationEnd',
        text: '完成离心',
        textPy: 'WCLX',
        label: '完成离心',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 9,
        name: 'FilterBegin',
        text: '开始滤白',
        textPy: 'KSLB',
        label: '开始滤白',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 10,
        name: 'FilterEnd',
        text: '结束虑白',
        textPy: 'JSLB',
        label: '结束虑白',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 11,
        name: 'BindBloodBag',
        text: '(特殊血液)血袋绑定',
        textPy: 'TSXYXDBD',
        label: '(特殊血液)血袋绑定',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 12,
        name: 'Validate4InProdStorage',
        text: '入成品库(前)核查',
        textPy: 'RCPKQHC',
        label: '入成品库(前)核查',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 13,
        name: 'Validate4OutProdStorage',
        text: '出成品库(后)核查',
        textPy: 'CCPKHHC',
        label: '出成品库(后)核查',
        color: '',
        icon: '',
        meta: null
      }

    ], '业务操作', '')
  }

  get None () {
    return 0
  }

  get QueryStorageUnchecked () {
    return 1
  }

  get QueryStorageChecked () {
    return 2
  }

  get InBox () {
    return 3
  }

  get OutBox () {
    return 4
  }

  get OutStorage () {
    return 5
  }

  get CheckStorage () {
    return 6
  }

  get CentrifugationBegin () {
    return 7
  }

  get CentrifugationEnd () {
    return 8
  }

  get FilterBegin () {
    return 9
  }

  get FilterEnd () {
    return 10
  }

  get BindBloodBag () {
    return 11
  }

  get Validate4InProdStorage () {
    return 12
  }

  get Validate4OutProdStorage () {
    return 13
  }
}

export const BizOperation = Object.freeze(new BizOperationType())

class BizStatusType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Unknown',
        text: '未知',
        textPy: 'WZ',
        label: '未知',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Valid',
        text: '合法',
        textPy: 'HF',
        label: '合法',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Invalid',
        text: '不合法',
        textPy: 'BHF',
        label: '不合法',
        color: '',
        icon: '',
        meta: null
      }

    ], '业务状态', '')
  }

  get Unknown () {
    return 0
  }

  get Valid () {
    return 1
  }

  get Invalid () {
    return 2
  }
}

export const BizStatus = Object.freeze(new BizStatusType())

class RfidReaderStateType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Unconnected',
        text: '未连接',
        textPy: 'WLJ',
        label: '未连接',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Connecting',
        text: '连接中',
        textPy: 'LJZ',
        label: '连接中',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Connected',
        text: '已连接',
        textPy: 'YLJ',
        label: '已连接',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'ReadStarting',
        text: '正在启动',
        textPy: 'ZZQD',
        label: '正在启动',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'ReadStarted',
        text: '已启动',
        textPy: 'YQD',
        label: '已启动',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 5,
        name: 'ReadStopping',
        text: '正在停止',
        textPy: 'ZZTZ',
        label: '正在停止',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 6,
        name: 'Disconnecting',
        text: '断开连接中',
        textPy: 'DKLJZ',
        label: '断开连接中',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 7,
        name: 'Aborted',
        text: '已中断',
        textPy: 'YZD',
        label: '已中断',
        color: '',
        icon: '',
        meta: null
      }

    ], 'RFID扫描仪状态', '')
  }

  get Unconnected () {
    return 0
  }

  get Connecting () {
    return 1
  }

  get Connected () {
    return 2
  }

  get ReadStarting () {
    return 3
  }

  get ReadStarted () {
    return 4
  }

  get ReadStopping () {
    return 5
  }

  get Disconnecting () {
    return 6
  }

  get Aborted () {
    return 7
  }
}

export const RfidReaderState = Object.freeze(new RfidReaderStateType())

class FingerprintReaderStateType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Unconnected',
        text: '未连接',
        textPy: 'WLJ',
        label: '未连接',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Connecting',
        text: '连接中',
        textPy: 'LJZ',
        label: '连接中',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Connected',
        text: '已连接',
        textPy: 'YLJ',
        label: '已连接',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'ReadStarting',
        text: '正在启动',
        textPy: 'ZZQD',
        label: '正在启动',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'ReadStarted',
        text: '已启动',
        textPy: 'YQD',
        label: '已启动',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 5,
        name: 'ReadStopping',
        text: '正在停止',
        textPy: 'ZZTZ',
        label: '正在停止',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 6,
        name: 'Disconnecting',
        text: '断开连接中',
        textPy: 'DKLJZ',
        label: '断开连接中',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 7,
        name: 'Aborted',
        text: '已中断',
        textPy: 'YZD',
        label: '已中断',
        color: '',
        icon: '',
        meta: null
      }

    ], 'RFID扫描仪状态', '')
  }

  get Unconnected () {
    return 0
  }

  get Connecting () {
    return 1
  }

  get Connected () {
    return 2
  }

  get ReadStarting () {
    return 3
  }

  get ReadStarted () {
    return 4
  }

  get ReadStopping () {
    return 5
  }

  get Disconnecting () {
    return 6
  }

  get Aborted () {
    return 7
  }
}

export const FingerprintReaderState = Object.freeze(new FingerprintReaderStateType())

class FingerprintStateType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Uncollect',
        text: '未采集',
        textPy: 'WCJ',
        label: '未采集',
        color: 'grey',
        icon: 'fingerprint',
        meta: null
      },

      {
        value: 1,
        name: 'Collecting',
        text: '采集中',
        textPy: 'CJZ',
        label: '采集中',
        color: 'primary',
        icon: 'pending',
        meta: null
      },

      {
        value: 2,
        name: 'Collected',
        text: '已采集',
        textPy: 'YCJ',
        label: '已采集',
        color: 'green',
        icon: 'done',
        meta: null
      }

    ], '指纹采集状态', '')
  }

  get Uncollect () {
    return 0
  }

  get Collecting () {
    return 1
  }

  get Collected () {
    return 2
  }
}

export const FingerprintState = Object.freeze(new FingerprintStateType())

class FingerTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'LeftLittleFinger',
        text: '左小指',
        textPy: 'ZXZ',
        label: '左小指',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'LeftRingFinger',
        text: '左无名指',
        textPy: 'ZWMZ',
        label: '左无名指',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'LeftMiddleFinger',
        text: '左中指',
        textPy: 'ZZZ',
        label: '左中指',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'LeftIndexFinger',
        text: '左食指',
        textPy: 'ZSZ',
        label: '左食指',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'LeftThumb',
        text: '左拇指',
        textPy: 'ZSMZ',
        label: '左拇指',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 5,
        name: 'RightLittleFinger',
        text: '右小指',
        textPy: 'YXZ',
        label: '右小指',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 6,
        name: 'RightRingFinger',
        text: '右无名指',
        textPy: 'YWMZ',
        label: '右无名指',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 7,
        name: 'RightMiddleFinger',
        text: '右中指',
        textPy: 'YZZ',
        label: '右中指',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 8,
        name: 'RightIndexFinger',
        text: '右食指',
        textPy: 'YSZ',
        label: '右食指',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 9,
        name: 'RightThumb',
        text: '右拇指',
        textPy: 'YMZ',
        label: '右拇指',
        color: '',
        icon: '',
        meta: null
      }

    ], '指纹类型', '')
  }

  get LeftLittleFinger () {
    return 0
  }

  get LeftRingFinger () {
    return 1
  }

  get LeftMiddleFinger () {
    return 2
  }

  get LeftIndexFinger () {
    return 3
  }

  get LeftThumb () {
    return 4
  }

  get RightLittleFinger () {
    return 5
  }

  get RightRingFinger () {
    return 6
  }

  get RightMiddleFinger () {
    return 7
  }

  get RightIndexFinger () {
    return 8
  }

  get RightThumb () {
    return 9
  }
}

export const FingerType = Object.freeze(new FingerTypeType())

class PickUserType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Operator',
        text: '操作人',
        textPy: 'CZR',
        label: '操作人',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Reviewer',
        text: '审核人',
        textPy: 'SHR',
        label: '审核人',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'HandoverSender',
        text: '交班人',
        textPy: 'JBR',
        label: '交班人',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'HandoverReceiver',
        text: '接班人',
        textPy: 'JBR',
        label: '接班人',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'Sender',
        text: '送交人',
        textPy: 'SJR',
        label: '送交人',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 5,
        name: 'Receiver',
        text: '接收人',
        textPy: 'JSR',
        label: '接收人',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 6,
        name: 'Archiver',
        text: '归档人',
        textPy: 'GDR',
        label: '归档人',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 7,
        name: 'Borrowers',
        text: '借阅人',
        textPy: 'JYR',
        label: '借阅人',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 8,
        name: 'Publishers',
        text: '发布人',
        textPy: 'FBR',
        label: '发布人',
        color: '',
        icon: '',
        meta: null
      }

    ], '操作人', '')
  }

  get Operator () {
    return 0
  }

  get Reviewer () {
    return 1
  }

  get HandoverSender () {
    return 2
  }

  get HandoverReceiver () {
    return 3
  }

  get Sender () {
    return 4
  }

  get Receiver () {
    return 5
  }

  get Archiver () {
    return 6
  }

  get Borrowers () {
    return 7
  }

  get Publishers () {
    return 8
  }
}

export const PickUser = Object.freeze(new PickUserType())

class HandoverStateType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Created',
        text: '已创建',
        textPy: 'YCJ',
        label: '已创建',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Committed',
        text: '已提交',
        textPy: 'YTJ',
        label: '已提交',
        color: '',
        icon: '',
        meta: null
      }

    ], '交接状态', '')
  }

  get Created () {
    return 0
  }

  get Committed () {
    return 1
  }
}

export const HandoverState = Object.freeze(new HandoverStateType())

class FieldDataTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Integer',
        text: '整数',
        textPy: 'ZS',
        label: '整数',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Float',
        text: '浮点数',
        textPy: 'FDS',
        label: '浮点数',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'DateTime',
        text: '时间',
        textPy: 'SJ',
        label: '时间',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'String',
        text: '字符串',
        textPy: 'ZFC',
        label: '字符串',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'Map',
        text: '键值对对象',
        textPy: 'JZDDX',
        label: '键值对对象',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 5,
        name: 'ValueArray',
        text: '值数组',
        textPy: 'ZSZ',
        label: '值数组',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 6,
        name: 'MapArray',
        text: '对象数组',
        textPy: 'DXSZ',
        label: '对象数组',
        color: '',
        icon: '',
        meta: null
      }

    ], '字段数据类型', '')
  }

  get Integer () {
    return 0
  }

  get Float () {
    return 1
  }

  get DateTime () {
    return 2
  }

  get String () {
    return 3
  }

  get Map () {
    return 4
  }

  get ValueArray () {
    return 5
  }

  get MapArray () {
    return 6
  }
}

export const FieldDataType = Object.freeze(new FieldDataTypeType())

class HandoverFieldStyleTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Default',
        text: '默认',
        textPy: 'MR',
        label: '默认',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Table1',
        text: '表格(全)',
        textPy: 'BGQ',
        label: '表格(全)',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Table2',
        text: '表格(半)',
        textPy: 'BGB',
        label: '表格(半)',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'Textarea',
        text: '文本域',
        textPy: 'WBY',
        label: '文本域',
        color: '',
        icon: '',
        meta: null
      }

    ], '交接班字段风格类型', '')
  }

  get Default () {
    return 0
  }

  get Table1 () {
    return 1
  }

  get Table2 () {
    return 2
  }

  get Textarea () {
    return 3
  }
}

export const HandoverFieldStyleType = Object.freeze(new HandoverFieldStyleTypeType())

class MaterialCapacityScaleType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'TwoHundred',
        text: '200mL',
        textPy: '200mL',
        label: '200mL',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'ThreeHundred',
        text: '300mL',
        textPy: '300mL',
        label: '300mL',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'FourHundred',
        text: '400mL',
        textPy: '400mL',
        label: '400mL',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'Others',
        text: '全血',
        textPy: 'QX',
        label: '全血',
        color: '',
        icon: '',
        meta: null
      }

    ], '采血容量刻度', '')
  }

  get TwoHundred () {
    return 0
  }

  get ThreeHundred () {
    return 1
  }

  get FourHundred () {
    return 2
  }

  get Others () {
    return 3
  }
}

export const MaterialCapacityScale = Object.freeze(new MaterialCapacityScaleType())

class ProductSourceCategoryType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Local',
        text: '自采血',
        textPy: 'ZCX',
        label: '自采血',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Foreign',
        text: '外来血',
        textPy: 'WLX',
        label: '外来血',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Self',
        text: '自身输血',
        textPy: 'ZSSX',
        label: '自身输血',
        color: '',
        icon: '',
        meta: null
      }

    ], '血液来源分类', '')
  }

  get Local () {
    return 0
  }

  get Foreign () {
    return 1
  }

  get Self () {
    return 2
  }
}

export const ProductSourceCategory = Object.freeze(new ProductSourceCategoryType())

class QcImportStateType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Done',
        text: '已导入',
        textPy: 'YDR',
        label: '已导入',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Undone',
        text: '未导入',
        textPy: 'WDR',
        label: '未导入',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'All',
        text: '全部',
        textPy: 'QB',
        label: '全部',
        color: '',
        icon: '',
        meta: null
      }

    ], '导入状态', '')
  }

  get Done () {
    return 0
  }

  get Undone () {
    return 1
  }

  get All () {
    return 2
  }
}

export const QcImportState = Object.freeze(new QcImportStateType())

class ThemeColorCategoryType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Brand',
        text: '基础颜色',
        textPy: 'JCYS',
        label: '基础颜色',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Action',
        text: '操作颜色',
        textPy: 'CZYS',
        label: '操作颜色',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Menu',
        text: '菜单颜色',
        textPy: 'CDYS',
        label: '菜单颜色',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'Object',
        text: '事物颜色',
        textPy: 'SWYS',
        label: '事物颜色',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'XBrand',
        text: '扩展基础颜色',
        textPy: 'KZJCYS',
        label: '扩展基础颜色',
        color: '',
        icon: '',
        meta: null
      }

    ], '主题颜色分类', '')
  }

  get Brand () {
    return 0
  }

  get Action () {
    return 1
  }

  get Menu () {
    return 2
  }

  get Object () {
    return 3
  }

  get XBrand () {
    return 4
  }
}

export const ThemeColorCategory = Object.freeze(new ThemeColorCategoryType())

class FingerprintIdentityTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Donator',
        text: '献血者',
        textPy: 'XXZ',
        label: '献血者',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'User',
        text: '用户',
        textPy: 'YH',
        label: '用户',
        color: '',
        icon: '',
        meta: null
      }

    ], '指纹标识类型', '')
  }

  get Donator () {
    return 0
  }

  get User () {
    return 1
  }
}

export const FingerprintIdentityType = Object.freeze(new FingerprintIdentityTypeType())

class StatisticsTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Material',
        text: '采血统计',
        textPy: 'CX',
        label: '采血统计',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Semiprod',
        text: '成分制备统计',
        textPy: 'CFZB',
        label: '成分制备统计',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Test',
        text: '检验统计',
        textPy: 'JY',
        label: '检验统计',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'Product',
        text: '成品库统计',
        textPy: 'CP',
        label: '成品库统计',
        color: '',
        icon: '',
        meta: null
      }

    ], '统计类型', '')
  }

  get Material () {
    return 0
  }

  get Semiprod () {
    return 1
  }

  get Test () {
    return 2
  }

  get Product () {
    return 3
  }
}

export const StatisticsType = Object.freeze(new StatisticsTypeType())

class StatisticsDatePeriodType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Day',
        text: '天',
        textPy: 'T',
        label: '天',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Week',
        text: '周',
        textPy: 'Z',
        label: '周',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Month',
        text: '月',
        textPy: 'Y',
        label: '月',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'Year',
        text: '年',
        textPy: 'N',
        label: '年',
        color: '',
        icon: '',
        meta: null
      }

    ], '统计日期周期', '')
  }

  get Day () {
    return 0
  }

  get Week () {
    return 1
  }

  get Month () {
    return 2
  }

  get Year () {
    return 3
  }
}

export const StatisticsDatePeriod = Object.freeze(new StatisticsDatePeriodType())

class StatisticsNumberDimensionType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Count',
        text: '袋数',
        textPy: 'DS',
        label: '袋数',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Capacity',
        text: '容量',
        textPy: 'RL',
        label: '容量',
        color: '',
        icon: '',
        meta: null
      }

    ], '统计数量维度', '')
  }

  get Count () {
    return 0
  }

  get Capacity () {
    return 1
  }
}

export const StatisticsNumberDimension = Object.freeze(new StatisticsNumberDimensionType())

class PatientSourceType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Native',
        text: '本地',
        textPy: 'BD',
        label: '本地',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Foreigner',
        text: '外地',
        textPy: 'WD',
        label: '外地',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Troops',
        text: '部队',
        textPy: 'BD',
        label: '部队',
        color: '',
        icon: '',
        meta: null
      }

    ], '患者属地', '')
  }

  get Native () {
    return 0
  }

  get Foreigner () {
    return 1
  }

  get Troops () {
    return 2
  }
}

export const PatientSource = Object.freeze(new PatientSourceType())

class BloodUsingMethodType extends EnumType {
  constructor () {
    super([

      {
        value: 1,
        name: 'Emergency',
        text: '急诊',
        textPy: 'JZ',
        label: '急诊',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Rule',
        text: '常规',
        textPy: 'CG',
        label: '常规',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'PrepareBlood',
        text: '备血',
        textPy: 'BX',
        label: '备血',
        color: '',
        icon: '',
        meta: null
      }

    ], '用血安排', '')
  }

  get Emergency () {
    return 1
  }

  get Rule () {
    return 2
  }

  get PrepareBlood () {
    return 3
  }
}

export const BloodUsingMethod = Object.freeze(new BloodUsingMethodType())

class CourtyardSouthType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'North',
        text: '院北',
        textPy: 'YB',
        label: '院北',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'South',
        text: '院南',
        textPy: 'YN',
        label: '院南',
        color: '',
        icon: '',
        meta: null
      }

    ], '院区', '')
  }

  get North () {
    return 0
  }

  get South () {
    return 1
  }
}

export const CourtyardSouth = Object.freeze(new CourtyardSouthType())

class GoodsOperationTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 1,
        name: 'Into',
        text: '入库',
        textPy: 'RK',
        label: '入库',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Out',
        text: '出库',
        textPy: 'CK',
        label: '出库',
        color: '',
        icon: '',
        meta: null
      }

    ], '物资管理类型', '')
  }

  get Into () {
    return 1
  }

  get Out () {
    return 2
  }
}

export const GoodsOperationType = Object.freeze(new GoodsOperationTypeType())

class GoodsOperationStateType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Wait',
        text: '等待',
        textPy: 'DD',
        label: '等待',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Done',
        text: '完成',
        textPy: 'WC',
        label: '完成',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Waste',
        text: '作废',
        textPy: 'WC',
        label: '作废',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'PartWaste',
        text: '部分作废',
        textPy: 'WC',
        label: '部分作废',
        color: '',
        icon: '',
        meta: null
      }

    ], '物资管理状态', '')
  }

  get Wait () {
    return 0
  }

  get Done () {
    return 1
  }

  get Waste () {
    return 2
  }

  get PartWaste () {
    return 3
  }
}

export const GoodsOperationState = Object.freeze(new GoodsOperationStateType())

class EquipmentType extends EnumType {
  constructor () {
    super([

      {
        value: 6,
        name: 'BloodBagLabel',
        text: '血袋标签',
        textPy: 'XDBQ',
        label: '血袋标签',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 7,
        name: 'VacuumBloodCollection',
        text: '真空采血管',
        textPy: 'ZKCXG',
        label: '真空采血管',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 8,
        name: 'Syringe',
        text: '注射器',
        textPy: 'ZSQ',
        label: '注射器',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 9,
        name: 'BloodBag',
        text: '血袋',
        textPy: 'XD',
        label: '血袋',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 10,
        name: 'DisposablePipe',
        text: '一次性使用管道',
        textPy: 'YCXSYGD',
        label: '一次性使用管道',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 11,
        name: 'DisposableWhiteBloodCellFilter',
        text: '一次性使用白细胞过滤器',
        textPy: 'YCXSYBXBGLQ',
        label: '一次性使用白细胞过滤器',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 12,
        name: 'ReagentQualityControl',
        text: '试剂质控',
        textPy: 'SJZK',
        label: '试剂质控',
        color: '',
        icon: '',
        meta: null
      }

    ], '设备类型', '')
  }

  get BloodBagLabel () {
    return 6
  }

  get VacuumBloodCollection () {
    return 7
  }

  get Syringe () {
    return 8
  }

  get BloodBag () {
    return 9
  }

  get DisposablePipe () {
    return 10
  }

  get DisposableWhiteBloodCellFilter () {
    return 11
  }

  get ReagentQualityControl () {
    return 12
  }
}

export const Equipment = Object.freeze(new EquipmentType())

class KeyEquipmentType extends EnumType {
  constructor () {
    super([

      {
        value: 13,
        name: 'ComponentPreparationBigCentrifuge',
        text: '成分制备大容量离心机',
        textPy: 'CFZBDRLLXJ',
        label: '成分制备大容量离心机',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 14,
        name: 'BloodStorageEquipment',
        text: '储血设备',
        textPy: 'CXSB',
        label: '储血设备',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 15,
        name: 'BloodSamplingScale',
        text: '采血称',
        textPy: 'CXC',
        label: '采血称',
        color: '',
        icon: '',
        meta: null
      }

    ], '关键设备', '')
  }

  get ComponentPreparationBigCentrifuge () {
    return 13
  }

  get BloodStorageEquipment () {
    return 14
  }

  get BloodSamplingScale () {
    return 15
  }
}

export const KeyEquipment = Object.freeze(new KeyEquipmentType())

class DestroyTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'TearUp',
        text: '撕毁',
        textPy: 'SH',
        label: '撕毁',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Smash',
        text: '粉碎',
        textPy: 'FS',
        label: '粉碎',
        color: '',
        icon: '',
        meta: null
      }

    ], '撕毁方式', '')
  }

  get TearUp () {
    return 0
  }

  get Smash () {
    return 1
  }
}

export const DestroyType = Object.freeze(new DestroyTypeType())

class InformationInputTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 1,
        name: 'Consultant',
        text: '咨询者信息录入',
        textPy: 'ZXZXXLR',
        label: '咨询者信息录入',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'BloodDonor',
        text: '献血者信息录入',
        textPy: 'XXZXXLR',
        label: '献血者信息录入',
        color: '',
        icon: '',
        meta: null
      }

    ], '信息录入类型', '')
  }

  get Consultant () {
    return 1
  }

  get BloodDonor () {
    return 2
  }
}

export const InformationInputType = Object.freeze(new InformationInputTypeType())

class RecruitmentPlanOptionsType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'NoOne',
        text: '无',
        textPy: 'W',
        label: '无',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'WholeBlood',
        text: '全血招募',
        textPy: 'QXZM',
        label: '全血招募',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Soterocyte',
        text: '血小板招募',
        textPy: 'XXBZM',
        label: '血小板招募',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'All',
        text: '全血&血小板招募',
        textPy: 'QXHXXBZM',
        label: '全血&血小板招募',
        color: '',
        icon: '',
        meta: null
      }

    ], '招募计划', '')
  }

  get NoOne () {
    return 0
  }

  get WholeBlood () {
    return 1
  }

  get Soterocyte () {
    return 2
  }

  get All () {
    return 3
  }
}

export const RecruitmentPlanOptions = Object.freeze(new RecruitmentPlanOptionsType())

class RecruitmentResultType extends EnumType {
  constructor () {
    super([

      {
        value: '成功',
        name: '成功',
        text: '成功',
        textPy: '成功',
        label: '成功',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: '延期',
        name: '延期',
        text: '延期',
        textPy: '延期',
        label: '延期',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: '流失',
        name: '流失',
        text: '流失',
        textPy: '流失',
        label: '流失',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: '其他',
        name: '其他',
        text: '其他',
        textPy: '其他',
        label: '其他',
        color: '',
        icon: '',
        meta: null
      }

    ], '招募结果', '')
  }

  get 成功 () {
    return '成功'
  }

  get 延期 () {
    return '延期'
  }

  get 流失 () {
    return '流失'
  }

  get 其他 () {
    return '其他'
  }
}

export const RecruitmentResult = Object.freeze(new RecruitmentResultType())

class RecruitmentStateType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'No',
        text: '未招募',
        textPy: 'WZM',
        label: '未招募',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Ok',
        text: '已招募',
        textPy: 'YZM',
        label: '已招募',
        color: '',
        icon: '',
        meta: null
      }

    ], '招募状态', '')
  }

  get No () {
    return 0
  }

  get Ok () {
    return 1
  }
}

export const RecruitmentState = Object.freeze(new RecruitmentStateType())

class DonatorRoleOptionsType extends EnumType {
  constructor () {
    super([

      {
        value: 1,
        name: 'Consultant',
        text: '咨询者',
        textPy: 'ZXZ',
        label: '咨询者',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'BloodDonor',
        text: '献血者',
        textPy: 'XXZ',
        label: '献血者',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'Registrant',
        text: '登记者',
        textPy: 'DJZ',
        label: '登记者',
        color: '',
        icon: '',
        meta: null
      }

    ], '献血者身份', '')
  }

  get Consultant () {
    return 1
  }

  get BloodDonor () {
    return 2
  }

  get Registrant () {
    return 3
  }
}

export const DonatorRoleOptions = Object.freeze(new DonatorRoleOptionsType())

class CrossMatchingYesOrNoType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'No',
        text: '是',
        textPy: 'F',
        label: '是',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Yes',
        text: '否',
        textPy: 'S',
        label: '否',
        color: '',
        icon: '',
        meta: null
      }

    ], '是否单独收费', '')
  }

  get No () {
    return 0
  }

  get Yes () {
    return 1
  }
}

export const CrossMatchingYesOrNo = Object.freeze(new CrossMatchingYesOrNoType())

class BloodDonationTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Free',
        text: '无偿',
        textPy: 'WC',
        label: '无偿',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Love',
        text: '爱心',
        textPy: 'AX',
        label: '爱心',
        color: '',
        icon: '',
        meta: null
      }

    ], '献血方式', 'offline_pin')
  }

  get Free () {
    return 0
  }

  get Love () {
    return 1
  }
}

export const BloodDonationType = Object.freeze(new BloodDonationTypeType())

class DonHisStatueType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'First',
        text: '首次',
        textPy: 'SC',
        label: '首次',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'OnceMore',
        text: '再次',
        textPy: 'ZC',
        label: '再次',
        color: '',
        icon: '',
        meta: null
      }

    ], '献血方式', 'offline_pin')
  }

  get First () {
    return 0
  }

  get OnceMore () {
    return 1
  }
}

export const DonHisStatue = Object.freeze(new DonHisStatueType())

class DonTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 1,
        name: 'WholeBlood',
        text: '全血',
        textPy: 'QX',
        label: '全血',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Platelet',
        text: '血小板',
        textPy: 'XXB',
        label: '血小板',
        color: '',
        icon: '',
        meta: null
      }

    ], '上次献血类型', 'offline_pin')
  }

  get WholeBlood () {
    return 1
  }

  get Platelet () {
    return 2
  }
}

export const DonType = Object.freeze(new DonTypeType())

class DonRecordTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'WholeBlood',
        text: '全血',
        textPy: 'QX',
        label: '全血',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'ConstituentBlood',
        text: '成分血',
        textPy: 'CFX',
        label: '成分血',
        color: '',
        icon: '',
        meta: null
      }

    ], '献血记录类型', 'offline_pin')
  }

  get WholeBlood () {
    return 0
  }

  get ConstituentBlood () {
    return 1
  }
}

export const DonRecordType = Object.freeze(new DonRecordTypeType())

class MigrantPopulationStateType extends EnumType {
  constructor () {
    super([

      {
        value: 1,
        name: 'Join',
        text: '已加入',
        textPy: 'YJR',
        label: '已加入',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Quit',
        text: '已退出',
        textPy: 'YTC',
        label: '已退出',
        color: '',
        icon: '',
        meta: null
      }

    ], '流动血库状态', '')
  }

  get Join () {
    return 1
  }

  get Quit () {
    return 2
  }
}

export const MigrantPopulationState = Object.freeze(new MigrantPopulationStateType())

class RequestPatientTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 1,
        name: 'Inpatient',
        text: '住院',
        textPy: 'ZY',
        label: '住院',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'Outpatient',
        text: '门诊',
        textPy: 'MZ',
        label: '门诊',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'InpatientEmergency',
        text: '住院急诊',
        textPy: 'ZYJZ',
        label: '住院急诊',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'OutpatientEmergency',
        text: '门诊急诊',
        textPy: 'MZJZ',
        label: '门诊急诊',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 5,
        name: 'Physical',
        text: '体检',
        textPy: 'TJ',
        label: '体检',
        color: '',
        icon: '',
        meta: null
      }

    ], '患者类别', '')
  }

  get Inpatient () {
    return 1
  }

  get Outpatient () {
    return 2
  }

  get InpatientEmergency () {
    return 3
  }

  get OutpatientEmergency () {
    return 4
  }

  get Physical () {
    return 5
  }
}

export const RequestPatientType = Object.freeze(new RequestPatientTypeType())

class InventoryTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'QueryStorage',
        text: '成品库',
        textPy: 'CPK',
        label: '成品库',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'CoreStorage',
        text: '战备库',
        textPy: 'ZBK',
        label: '战备库',
        color: '',
        icon: '',
        meta: null
      }

    ], '库存类型', '')
  }

  get QueryStorage () {
    return 0
  }

  get CoreStorage () {
    return 1
  }
}

export const InventoryType = Object.freeze(new InventoryTypeType())

class CollectCategoryType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Separate',
        text: '自采',
        textPy: 'ZC',
        label: '自采',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Team',
        text: '团采',
        textPy: 'TC',
        label: '团采',
        color: '',
        icon: '',
        meta: null
      }

    ], '采集方式', '')
  }

  get Separate () {
    return 0
  }

  get Team () {
    return 1
  }
}

export const CollectCategory = Object.freeze(new CollectCategoryType())

class TransfusionReactionType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'None',
        text: '无',
        textPy: 'NONE',
        label: '无',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Have',
        text: '有',
        textPy: 'HAVE',
        label: '有',
        color: '',
        icon: '',
        meta: null
      }

    ], '输血反应', 'wc')
  }

  get None () {
    return 0
  }

  get Have () {
    return 1
  }
}

export const TransfusionReaction = Object.freeze(new TransfusionReactionType())

class ApplyReciveStateType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Yes',
        text: '未接收',
        textPy: 'YES',
        label: '未接收',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'No',
        text: '已接收',
        textPy: 'NO',
        label: '已接收',
        color: '',
        icon: '',
        meta: null
      }

    ], '申请单接收状态', '')
  }

  get Yes () {
    return 0
  }

  get No () {
    return 1
  }
}

export const ApplyReciveState = Object.freeze(new ApplyReciveStateType())

class BloodTypingExperimentalStatusType extends EnumType {
  constructor () {
    super([

      {
        value: 1,
        name: 'Received',
        text: '已接收',
        textPy: '已接收',
        label: '已接收',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'NoExamine',
        text: '未审核',
        textPy: '未审核',
        label: '未审核',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'YesExamine',
        text: '已审核',
        textPy: '已审核',
        label: '已审核',
        color: '',
        icon: '',
        meta: null
      }

    ], '实验状态', 'catching_pokemon')
  }

  get Received () {
    return 1
  }

  get NoExamine () {
    return 2
  }

  get YesExamine () {
    return 3
  }
}

export const BloodTypingExperimentalStatus = Object.freeze(new BloodTypingExperimentalStatusType())

class LogExperimentalStatusType extends EnumType {
  constructor () {
    super([

      {
        value: 4,
        name: 'Published',
        text: '已发布',
        textPy: '已发布',
        label: '已发布',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 5,
        name: 'Printed',
        text: '已打印',
        textPy: '已打印',
        label: '已打印',
        color: '',
        icon: '',
        meta: null
      }

    ], '实验状态', 'catching_pokemon')
  }

  get Published () {
    return 4
  }

  get Printed () {
    return 5
  }
}

export const LogExperimentalStatus = Object.freeze(new LogExperimentalStatusType())

class TransfusionBloodRhType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Positive',
        text: '+',
        textPy: '+',
        label: '+',
        color: '',
        icon: '',
        meta: {"labelStyle":"font-size: 2em"}
      },

      {
        value: 1,
        name: 'Negative',
        text: '-',
        textPy: '-',
        label: '-',
        color: '',
        icon: '',
        meta: {"labelStyle":"font-size: 2em"}
      },

      {
        value: 9,
        name: 'YC',
        text: '已抽血, 结果待报',
        textPy: 'YC',
        label: '已抽血, 结果待报',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 10,
        name: 'WZ',
        text: '未做',
        textPy: 'WZ',
        label: '未做',
        color: '',
        icon: '',
        meta: null
      }

    ], 'Rh(D)', 'bloodtype')
  }

  get Positive () {
    return 0
  }

  get Negative () {
    return 1
  }

  get YC () {
    return 9
  }

  get WZ () {
    return 10
  }
}

export const TransfusionBloodRh = Object.freeze(new TransfusionBloodRhType())

class TransfusionTestResultType extends EnumType {
  constructor () {
    super([

      {
        value: 1,
        name: 'Positive',
        text: '+',
        textPy: '+',
        label: '+',
        color: '',
        icon: '',
        meta: {"labelStyle":"font-size: 2em"}
      },

      {
        value: 2,
        name: 'Negative',
        text: '-',
        textPy: '-',
        label: '-',
        color: '',
        icon: '',
        meta: {"labelStyle":"font-size: 2em"}
      },

      {
        value: 9,
        name: 'YC',
        text: '已抽血, 结果待报',
        textPy: 'YC',
        label: '已抽血, 结果待报',
        color: 'green',
        icon: '',
        meta: null
      },

      {
        value: 10,
        name: 'WZ',
        text: '未做',
        textPy: 'WZ',
        label: '未做',
        color: 'red',
        icon: '',
        meta: null
      }

    ], '检验结果', 'bloodtype')
  }

  get Positive () {
    return 1
  }

  get Negative () {
    return 2
  }

  get YC () {
    return 9
  }

  get WZ () {
    return 10
  }
}

export const TransfusionTestResult = Object.freeze(new TransfusionTestResultType())

class TransfusionBloodGroupType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'A',
        text: 'A',
        textPy: 'A',
        label: 'A',
        color: 'yellow-9',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'B',
        text: 'B',
        textPy: 'B',
        label: 'B',
        color: 'red',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'O',
        text: 'O',
        textPy: 'O',
        label: 'O',
        color: 'blue',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'AB',
        text: 'AB',
        textPy: 'AB',
        label: 'AB',
        color: 'green',
        icon: '',
        meta: null
      },

      {
        value: 9,
        name: 'YC',
        text: '已抽血, 结果待报',
        textPy: 'YC',
        label: '已抽血, 结果待报',
        color: 'green',
        icon: '',
        meta: null
      },

      {
        value: 10,
        name: 'WZ',
        text: '未做',
        textPy: 'WZ',
        label: '未做',
        color: 'red',
        icon: '',
        meta: null
      }

    ], '血型', 'opacity')
  }

  get A () {
    return 0
  }

  get B () {
    return 1
  }

  get O () {
    return 2
  }

  get AB () {
    return 3
  }

  get YC () {
    return 9
  }

  get WZ () {
    return 10
  }
}

export const TransfusionBloodGroup = Object.freeze(new TransfusionBloodGroupType())

class ThemeColorType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Primary',
        text: '主调',
        textPy: 'ZD',
        label: '主调',
        color: '#245466',
        icon: '',
        meta: {"category":0}
      },

      {
        value: 1,
        name: 'Secondary',
        text: '辅调',
        textPy: 'FD',
        label: '辅调',
        color: '#26a69a',
        icon: '',
        meta: {"category":0}
      },

      {
        value: 2,
        name: 'Accent',
        text: '强调',
        textPy: 'QD',
        label: '强调',
        color: '#9c27b0',
        icon: '',
        meta: {"category":0}
      },

      {
        value: 3,
        name: 'Dark',
        text: '暗黑',
        textPy: 'AH',
        label: '暗黑',
        color: '#1d1d1d',
        icon: '',
        meta: {"category":0}
      },

      {
        value: 4,
        name: 'Positive',
        text: '成功',
        textPy: 'CG',
        label: '成功',
        color: '#149132',
        icon: '',
        meta: {"category":0}
      },

      {
        value: 5,
        name: 'Negative',
        text: '失败',
        textPy: 'SB',
        label: '失败',
        color: '#c10015',
        icon: '',
        meta: {"category":0}
      },

      {
        value: 6,
        name: 'Info',
        text: '信息',
        textPy: 'XX',
        label: '信息',
        color: '#31ccec',
        icon: '',
        meta: {"category":0}
      },

      {
        value: 7,
        name: 'Warning',
        text: '警告',
        textPy: 'JG',
        label: '警告',
        color: '#f2c037',
        icon: '',
        meta: {"category":0}
      },

      {
        value: 100,
        name: 'ActionGet',
        text: '获取',
        textPy: 'CX',
        label: '获取',
        color: '#31ccec',
        icon: '',
        meta: {"category":1}
      },

      {
        value: 101,
        name: 'ActionAdd',
        text: '新增',
        textPy: 'XZ',
        label: '新增',
        color: '#008BBF',
        icon: '',
        meta: {"category":1}
      },

      {
        value: 102,
        name: 'ActionEdit',
        text: '修改',
        textPy: 'XG',
        label: '修改',
        color: '#fb8c00',
        icon: '',
        meta: {"category":1}
      },

      {
        value: 103,
        name: 'ActionDelete',
        text: '删除',
        textPy: 'SC',
        label: '删除',
        color: '#f44336',
        icon: '',
        meta: {"category":1}
      },

      {
        value: 104,
        name: 'ActionView',
        text: '查看',
        textPy: 'SC',
        label: '查看',
        color: '#31ccec',
        icon: '',
        meta: {"category":1}
      },

      {
        value: 105,
        name: 'ActionSave',
        text: '保存',
        textPy: 'BC',
        label: '保存',
        color: '#21ba45',
        icon: '',
        meta: {"category":1}
      },

      {
        value: 106,
        name: 'ActionCommit',
        text: '提交',
        textPy: 'TJ',
        label: '提交',
        color: '#03a9f4',
        icon: '',
        meta: {"category":1}
      },

      {
        value: 107,
        name: 'ActionReset',
        text: '重置',
        textPy: 'CZ',
        label: '重置',
        color: '#26a69a',
        icon: '',
        meta: {"category":1}
      },

      {
        value: 108,
        name: 'ActionCancel',
        text: '取消',
        textPy: 'TZ',
        label: '取消',
        color: '#f44336',
        icon: '',
        meta: {"category":1}
      },

      {
        value: 109,
        name: 'ActionOk',
        text: '确定',
        textPy: 'QD',
        label: '确定',
        color: '#21ba45',
        icon: '',
        meta: {"category":1}
      },

      {
        value: 110,
        name: 'ActionPrint',
        text: '打印',
        textPy: 'DY',
        label: '打印',
        color: '#757575',
        icon: '',
        meta: {"category":1}
      },

      {
        value: 111,
        name: 'ActionImport',
        text: '导入',
        textPy: 'DR',
        label: '导入',
        color: '#9c27b0',
        icon: '',
        meta: {"category":1}
      },

      {
        value: 112,
        name: 'ActionExport',
        text: '导出',
        textPy: 'DC',
        label: '导出',
        color: '#00796b',
        icon: '',
        meta: {"category":1}
      },

      {
        value: 113,
        name: 'ActionRecords',
        text: '记录',
        textPy: 'JL',
        label: '记录',
        color: '#607d8b',
        icon: '',
        meta: {"category":1}
      },

      {
        value: 114,
        name: 'ActionStart',
        text: '启动',
        textPy: 'QD',
        label: '启动',
        color: '#008BBF',
        icon: '',
        meta: {"category":1}
      },

      {
        value: 115,
        name: 'ActionStop',
        text: '停止',
        textPy: 'TZ',
        label: '停止',
        color: '#f44336',
        icon: '',
        meta: {"category":1}
      },

      {
        value: 116,
        name: 'ActionConfigure',
        text: '配置',
        textPy: 'PZ',
        label: '配置',
        color: '#757575',
        icon: '',
        meta: {"category":1}
      },

      {
        value: 117,
        name: 'ActionCheck',
        text: '核查',
        textPy: 'HC',
        label: '核查',
        color: '#4A5207',
        icon: '',
        meta: {"category":1}
      },

      {
        value: 118,
        name: 'ActionRevert',
        text: '撤销',
        textPy: 'CX',
        label: '撤销',
        color: '#c10015',
        icon: '',
        meta: {"category":1}
      },

      {
        value: 119,
        name: 'ActionSelected',
        text: '选中',
        textPy: 'XZ',
        label: '选中',
        color: '#d9d9d9',
        icon: '',
        meta: {"category":1}
      },

      {
        value: 120,
        name: 'ActionActive',
        text: '激活',
        textPy: 'JH',
        label: '激活',
        color: '#bfa45a',
        icon: '',
        meta: {"category":1}
      },

      {
        value: 200,
        name: 'ModuleHome',
        text: '首页',
        textPy: 'SY',
        label: '首页',
        color: '#027be3',
        icon: '',
        meta: {"category":2}
      },

      {
        value: 201,
        name: 'ModuleDon',
        text: '血源档案',
        textPy: 'XYDA',
        label: '血源档案',
        color: '#d50000',
        icon: '',
        meta: {"category":2}
      },

      {
        value: 202,
        name: 'ModuleSemiprod',
        text: '采血成分',
        textPy: 'CXCF',
        label: '采血成分',
        color: '#fb8c00',
        icon: '',
        meta: {"category":2}
      },

      {
        value: 203,
        name: 'ModuleTest',
        text: '血液检验',
        textPy: 'XYJY',
        label: '血液检验',
        color: '#03a9f4',
        icon: '',
        meta: {"category":2}
      },

      {
        value: 204,
        name: 'ModuleProduct',
        text: '成品管理',
        textPy: 'CPGL',
        label: '成品管理',
        color: '#546e7a',
        icon: '',
        meta: {"category":2}
      },

      {
        value: 205,
        name: 'ModuleTransfusion',
        text: '输血管理',
        textPy: 'SXGL',
        label: '输血管理',
        color: '#388e3c',
        icon: '',
        meta: {"category":2}
      },

      {
        value: 206,
        name: 'ModuleSettings',
        text: '系统配置',
        textPy: 'XTPZ',
        label: '系统配置',
        color: '#757575',
        icon: '',
        meta: {"category":2}
      },

      {
        value: 301,
        name: 'ObjectPatient',
        text: '患者',
        textPy: 'HZ',
        label: '患者',
        color: '#f6aa00',
        icon: '',
        meta: {"category":3}
      },

      {
        value: 302,
        name: 'ObjectBill',
        text: '账单',
        textPy: 'ZD',
        label: '账单',
        color: '#F5BA8A',
        icon: '',
        meta: {"category":3}
      },

      {
        value: 400,
        name: 'ThemeBg',
        text: '背景色(动态)',
        textPy: 'BJSDT',
        label: '背景色(动态)',
        color: '#EDF7F7',
        icon: '',
        meta: {"category":4}
      },

      {
        value: 401,
        name: 'ThemeBgLight',
        text: '明亮背景色',
        textPy: 'MLBJS',
        label: '明亮背景色',
        color: '#EDF7F7',
        icon: '',
        meta: {"category":4}
      }

    ], '主题颜色', '')
  }

  get Primary () {
    return 0
  }

  get Secondary () {
    return 1
  }

  get Accent () {
    return 2
  }

  get Dark () {
    return 3
  }

  get Positive () {
    return 4
  }

  get Negative () {
    return 5
  }

  get Info () {
    return 6
  }

  get Warning () {
    return 7
  }

  get ActionGet () {
    return 100
  }

  get ActionAdd () {
    return 101
  }

  get ActionEdit () {
    return 102
  }

  get ActionDelete () {
    return 103
  }

  get ActionView () {
    return 104
  }

  get ActionSave () {
    return 105
  }

  get ActionCommit () {
    return 106
  }

  get ActionReset () {
    return 107
  }

  get ActionCancel () {
    return 108
  }

  get ActionOk () {
    return 109
  }

  get ActionPrint () {
    return 110
  }

  get ActionImport () {
    return 111
  }

  get ActionExport () {
    return 112
  }

  get ActionRecords () {
    return 113
  }

  get ActionStart () {
    return 114
  }

  get ActionStop () {
    return 115
  }

  get ActionConfigure () {
    return 116
  }

  get ActionCheck () {
    return 117
  }

  get ActionRevert () {
    return 118
  }

  get ActionSelected () {
    return 119
  }

  get ActionActive () {
    return 120
  }

  get ModuleHome () {
    return 200
  }

  get ModuleDon () {
    return 201
  }

  get ModuleSemiprod () {
    return 202
  }

  get ModuleTest () {
    return 203
  }

  get ModuleProduct () {
    return 204
  }

  get ModuleTransfusion () {
    return 205
  }

  get ModuleSettings () {
    return 206
  }

  get ObjectPatient () {
    return 301
  }

  get ObjectBill () {
    return 302
  }

  get ThemeBg () {
    return 400
  }

  get ThemeBgLight () {
    return 401
  }
}

export const ThemeColor = Object.freeze(new ThemeColorType())

class TestTypeType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'Initial',
        text: '初检',
        textPy: 'CJ',
        label: '初检',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'Confirm',
        text: '复检',
        textPy: 'FJ',
        label: '复检',
        color: '',
        icon: '',
        meta: null
      }

    ], '检验类型', '')
  }

  get Initial () {
    return 0
  }

  get Confirm () {
    return 1
  }
}

export const TestType = Object.freeze(new TestTypeType())

class BloodGroupWordType extends EnumType {
  constructor () {
    super([

      {
        value: 200,
        name: 'A',
        text: 'A',
        textPy: 'A',
        label: 'A',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 201,
        name: 'B',
        text: 'B',
        textPy: 'B',
        label: 'B',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 202,
        name: 'O',
        text: 'O',
        textPy: 'O',
        label: 'O',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 203,
        name: 'AB',
        text: 'AB',
        textPy: 'AB',
        label: 'AB',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 204,
        name: 'Omitted',
        text: '不做',
        textPy: 'BZ',
        label: '不做',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 205,
        name: 'A1',
        text: 'A1',
        textPy: 'A1',
        label: 'A1',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 206,
        name: 'A2',
        text: 'A2',
        textPy: 'A2',
        label: 'A2',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 207,
        name: 'A1B',
        text: 'A1B',
        textPy: 'A1B',
        label: 'A1B',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 208,
        name: 'A2B',
        text: 'A2B',
        textPy: 'A2B',
        label: 'A2B',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 209,
        name: 'ASub',
        text: 'A亚型',
        textPy: 'AYX',
        label: 'A亚型',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 210,
        name: 'Unknown',
        text: '/',
        textPy: '/',
        label: '/',
        color: '',
        icon: '',
        meta: null
      }

    ], '血型', '')
  }

  get A () {
    return 200
  }

  get B () {
    return 201
  }

  get O () {
    return 202
  }

  get AB () {
    return 203
  }

  get Omitted () {
    return 204
  }

  get A1 () {
    return 205
  }

  get A2 () {
    return 206
  }

  get A1B () {
    return 207
  }

  get A2B () {
    return 208
  }

  get ASub () {
    return 209
  }

  get Unknown () {
    return 210
  }
}

export const BloodGroupWord = Object.freeze(new BloodGroupWordType())

class BloodRhWordType extends EnumType {
  constructor () {
    super([

      {
        value: 300,
        name: 'Positive',
        text: '+',
        textPy: '+',
        label: '+',
        color: '',
        icon: '',
        meta: {"labelStyle":"font-size: 2em"}
      },

      {
        value: 301,
        name: 'Negative',
        text: '-',
        textPy: '-',
        label: '-',
        color: '',
        icon: '',
        meta: {"labelStyle":"font-size: 2em"}
      },

      {
        value: 302,
        name: 'Omitted',
        text: '不做',
        textPy: 'BZ',
        label: '不做',
        color: '',
        icon: '',
        meta: null
      }

    ], 'Rh', '')
  }

  get Positive () {
    return 300
  }

  get Negative () {
    return 301
  }

  get Omitted () {
    return 302
  }
}

export const BloodRhWord = Object.freeze(new BloodRhWordType())

class BloodRhWordTypesType extends EnumType {
  constructor () {
    super([

      {
        value: 300,
        name: 'Positive',
        text: '+',
        textPy: '+',
        label: '+',
        color: '',
        icon: '',
        meta: {"labelStyle":"font-size: 2em"}
      },

      {
        value: 301,
        name: 'Negative',
        text: '-',
        textPy: '-',
        label: '-',
        color: '',
        icon: '',
        meta: {"labelStyle":"font-size: 2em"}
      }

    ], 'Rh', '')
  }

  get Positive () {
    return 300
  }

  get Negative () {
    return 301
  }
}

export const BloodRhWordTypes = Object.freeze(new BloodRhWordTypesType())

class CollectTimeIntervalType extends EnumType {
  constructor () {
    super([

      {
        value: 13,
        name: 'ge13Days',
        text: '≥13天',
        textPy: '≥13天',
        label: '≥13天',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 365,
        name: 'ge365Days',
        text: '≥365天',
        textPy: '≥365天',
        label: '≥365天',
        color: '',
        icon: '',
        meta: null
      }

    ], '已采天数', '')
  }

  get ge13Days () {
    return 13
  }

  get ge365Days () {
    return 365
  }
}

export const CollectTimeInterval = Object.freeze(new CollectTimeIntervalType())

class ReferenceRangeType extends EnumType {
  constructor () {
    super([

      {
        value: 16000019,
        name: 'HighValue',
        text: '高值',
        textPy: 'GZ',
        label: '高值',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 16000020,
        name: 'LowValue',
        text: '低值',
        textPy: 'DZ',
        label: '低值',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 16000021,
        name: 'normalValue',
        text: '正常',
        textPy: 'ZC',
        label: '正常',
        color: '',
        icon: '',
        meta: null
      },

      {
        value: 16000222,
        name: 'SpecialValue',
        text: '异常',
        textPy: 'YC',
        label: '异常',
        color: '',
        icon: '',
        meta: null
      }

    ], '参考范围', '')
  }

  get HighValue () {
    return 16000019
  }

  get LowValue () {
    return 16000020
  }

  get normalValue () {
    return 16000021
  }

  get SpecialValue () {
    return 16000222
  }
}

export const ReferenceRange = Object.freeze(new ReferenceRangeType())

class PatientBloodGroupType extends EnumType {
  constructor () {
    super([

      {
        value: 0,
        name: 'A',
        text: 'A',
        textPy: 'A',
        label: 'A',
        color: 'yellow-9',
        icon: '',
        meta: null
      },

      {
        value: 1,
        name: 'B',
        text: 'B',
        textPy: 'B',
        label: 'B',
        color: 'red',
        icon: '',
        meta: null
      },

      {
        value: 2,
        name: 'O',
        text: 'O',
        textPy: 'O',
        label: 'O',
        color: 'blue',
        icon: '',
        meta: null
      },

      {
        value: 3,
        name: 'AB',
        text: 'AB',
        textPy: 'AB',
        label: 'AB',
        color: 'green',
        icon: '',
        meta: null
      },

      {
        value: 4,
        name: 'AY',
        text: 'A亚型',
        textPy: 'A亚型',
        label: 'A亚型',
        color: 'yellow-9',
        icon: '',
        meta: null
      },

      {
        value: 5,
        name: 'BY',
        text: 'B亚型',
        textPy: 'B亚型',
        label: 'B亚型',
        color: 'red',
        icon: '',
        meta: null
      },

      {
        value: 7,
        name: 'OY',
        text: 'O亚型',
        textPy: 'O亚型',
        label: 'O亚型',
        color: 'green',
        icon: '',
        meta: null
      },

      {
        value: 8,
        name: 'ABY',
        text: 'AB亚型',
        textPy: 'AB亚型',
        label: 'AB亚型',
        color: 'green',
        icon: '',
        meta: null
      },

      {
        value: 9,
        name: 'Omh',
        text: 'Omh类孟买',
        textPy: 'Omh类孟买',
        label: 'Omh类孟买',
        color: 'green',
        icon: '',
        meta: null
      },

      {
        value: 10,
        name: 'Oh',
        text: 'Oh孟买型',
        textPy: 'Oh孟买型',
        label: 'Oh孟买型',
        color: 'green',
        icon: '',
        meta: null
      },

      {
        value: 11,
        name: 'Inconsistent',
        text: '正定型/反定型',
        textPy: '正定型/反定型',
        label: '正定型/反定型',
        color: 'green',
        icon: '',
        meta: null
      },

      {
        value: 12,
        name: 'AYB',
        text: 'A亚型B',
        textPy: 'A亚型B',
        label: 'A亚型B',
        color: 'green',
        icon: '',
        meta: null
      },

      {
        value: 13,
        name: 'Ab',
        text: 'A(B)',
        textPy: 'A(B)',
        label: 'A(B)',
        color: 'green',
        icon: '',
        meta: null
      },

      {
        value: 14,
        name: 'Ba',
        text: 'B(A)',
        textPy: 'B(A)',
        label: 'B(A)',
        color: 'green',
        icon: '',
        meta: null
      }

    ], '患者血型', 'opacity')
  }

  get A () {
    return 0
  }

  get B () {
    return 1
  }

  get O () {
    return 2
  }

  get AB () {
    return 3
  }

  get AY () {
    return 4
  }

  get BY () {
    return 5
  }

  get OY () {
    return 7
  }

  get ABY () {
    return 8
  }

  get Omh () {
    return 9
  }

  get Oh () {
    return 10
  }

  get Inconsistent () {
    return 11
  }

  get AYB () {
    return 12
  }

  get Ab () {
    return 13
  }

  get Ba () {
    return 14
  }
}

export const PatientBloodGroup = Object.freeze(new PatientBloodGroupType())

const enums = Object.freeze({

  YesOrNo,
  OrderState,
  TestResult,
  ComponentType,
  TestConclusion,
  BloodType,
  CollectMethods,
  Sex,
  BloodGroup,
  BloodRh,
  IdCardType,
  BloodUnit,
  WordEntryState,
  EducationDegree,
  Nation,
  ConfigItemScope,
  ConfigItemDataType,
  HealthStatus,
  MaterialOperationType,
  TestState,
  BloodTestState,
  ExamineState,
  TransfusionState,
  PubilshState,
  PossFourPubilshStates,
  PossFourExamineStates,
  PossFourTestResult,
  TransPossFourTestResult,
  DisplayTestState,
  TestResultTypes,
  ComponentMaterialFlag,
  ComponentSemiprodFlag,
  ComponentOperationFlag,
  ComponentExpireStart,
  DonatorFilter,
  TestItemToken,
  PossFourTestItemToken,
  TestNucleicAcidItemToken,
  TestItemShort,
  TestDevice,
  InstrumentType,
  TestNucleicAcidDevice,
  FourInfectiousDiseaseDevice,
  DateRange,
  DateRange2,
  DateRange3,
  DateRange4,
  GroupType,
  MaterialState,
  SpecimenHandoverOperationType,
  SemiprodState,
  ProdState,
  SemiprodOperationType,
  CheckState,
  ProductOperationType,
  PromptLevel,
  IcfState,
  PatientOrigin,
  Ifi,
  FeeIfi,
  ReagentState,
  UserStatus,
  RoleStatus,
  RoleDataScope,
  ReagentType,
  SpecimenType,
  SpecimenState,
  TransfusionSelfState,
  TransfusionalPriority,
  InstrumentFileState,
  InstrumentUsage,
  BizOperation,
  BizStatus,
  RfidReaderState,
  FingerprintReaderState,
  FingerprintState,
  FingerType,
  PickUser,
  HandoverState,
  FieldDataType,
  HandoverFieldStyleType,
  MaterialCapacityScale,
  ProductSourceCategory,
  QcImportState,
  ThemeColorCategory,
  FingerprintIdentityType,
  StatisticsType,
  StatisticsDatePeriod,
  StatisticsNumberDimension,
  PatientSource,
  BloodUsingMethod,
  CourtyardSouth,
  GoodsOperationType,
  GoodsOperationState,
  Equipment,
  KeyEquipment,
  DestroyType,
  InformationInputType,
  RecruitmentPlanOptions,
  RecruitmentResult,
  RecruitmentState,
  DonatorRoleOptions,
  CrossMatchingYesOrNo,
  BloodDonationType,
  DonHisStatue,
  DonType,
  DonRecordType,
  MigrantPopulationState,
  RequestPatientType,
  InventoryType,
  CollectCategory,
  TransfusionReaction,
  ApplyReciveState,
  BloodTypingExperimentalStatus,
  LogExperimentalStatus,
  TransfusionBloodRh,
  TransfusionTestResult,
  TransfusionBloodGroup,
  ThemeColor,
  TestType,
  BloodGroupWord,
  BloodRhWord,
  BloodRhWordTypes,
  CollectTimeInterval,
  ReferenceRange,
  PatientBloodGroup
})

Object.defineProperty(Vue.prototype, '$enums', {
  get () {
    return enums
  }
})

export default enums
